/**
 * BookingIntermediatrypage.jsx
 * Module: PaymentSection / Booking
 *
 * Intermediary booking-confirmation screen shown after a rate is selected.
 * Renders the flight summary, payment breakdown (including the Taxable
 * Amount / GST Amount / Net Amount split) and goods description, lets the
 * user attach/generate an AWB number, and dispatches either a new booking
 * (requestType "1") or an update to an existing booking (requestType "2").
 *
 * Author: FreightSee frontend team
 * Date: 2026-07-06
 */
import React, { useState, useEffect, useMemo } from "react";
import { Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { airport_list } from "../../../store/Admin/Common/CommonSlice";
// import { searchratestate  } from "../../../store/SearchRates/SearchRatesSlice";
// import {clearStoredSearch} from "../../../store/Newsearchform/Newsearchform"
import {
  booking,
  bookingupdate,
  lattao,
  getawb,
  selectBookingId,
} from "../../../store/BookingIntermediaterypage/airlineairportslice";
// import { updatenotificationdata } from "../../../store/Admin/Common/CommonSlice";
import { formatrates } from "../../../functions/Utils";
import { selectStoredAwbNumber } from "../../../store/Newslices/awbSlice";
import { selectStoredBookingId } from "../../../store/Newslices/bookingIdSlice";

import { updatenotificationdata } from "../../../store/Admin/Common/CommonSlice";
import { getsinglebookingdata } from "../../../store/BookingHistory/BookingHistorySlice";
import { httpinstance } from "../../../axios/api";
import {
  updateStoredSearch,
  clearStoredSearch,
} from "../../../store/Newsearchform/Newsearchform";
// import { SpinContainer } from "../../../StyledComponents/Queries";
// import { clearState } from "../../../store/BookingIntermediaterypage/airlineairportslice";
import { clearstate } from "../../../store/SearchRates/SearchRatesSlice";
import { viewBreakUp, searchratestate } from "../../../store/SearchRates/SearchRatesSlice";
import { buildRateSearchPayload } from "../../../utils/buildRateSearchPayload";
import useLogCreditLimit from "../../../utils/useLogCreditLimit";
import { getEkRateQuotationID } from "../../../utils/ekRate";
import {
  createOceanBooking,
  confirmKamOceanBooking,
} from "../../../store/SearchRates/SearchRatesSlice";
import { ToastContainer, toast } from "react-toastify";
// import {httpinstance} from '../../../axios/api';
import "react-toastify/dist/ReactToastify.css";
import {
  CHARGE_COLORS,
  resolveStoredCommodity,
  resolveTemperatureRange,
  resolveProductCommodityDetails,
} from "../BookingDetailUI";
import { Snowflake } from "lucide-react";
import { OCEAN_CARGO_TYPE_CODE_LABELS } from "../../../utils/constant";
import {
  containerLineWeight,
  containerWeightLabel,
  totalContainerWeight,
} from "../../../utils/oceanContainerWeight";
import {
  chargeLinesFromCharges,
  groupChargesByContainer,
} from "../../../forms/SearchRates/ShipmentRate/ContainerRates/groupChargesByContainer";
import OceanContainerChargeBreakdown from "../../BookingHistory/OceanContainerChargeBreakdown";
import Bl_notable from "../Bl_notable";
import { authuser } from "../../../store/Authentication/AuthSlice";
const Bookingintermediatrypage = ({
  queryidofflinepayment,
  props,
  isOpen,
  selectedItem,
  onClose,
  title,
  nodeData1,
  onConfirm,
  canEditAwb = false,
  requestType: requestTypeProp = "1",
  redirectPath = "/booking-history",
  pageMode = false,
}) => {
  console.log(selectedItem, "selectedItem");
  const navigate = useNavigate();
  const itemRatesFrom =
    selectedItem?.flightItineraries?.[0]?.rates_from ?? selectedItem?.ratesFrom;
  // Offline (stored/manual) rates carry `space_availability` on the selected
  // option from /ratesearch/all — the booking payload has to send the same
  // number back. Online carrier rates omit the key — then this is null and
  // nothing is added (spreading null is a no-op), so the booking stores no
  // space and the booking-detail pages leave the Space Availability cell out.
  const spaceAvailabilityFields =
    selectedItem?.space_availability !== undefined &&
    selectedItem?.space_availability !== null
      ? { space_availability: selectedItem.space_availability }
      : null;
  const [selectedValue, setSelectedValue] = useState("Paper AWB");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [awbNumber, setAwbNumber] = useState(""); // Holds the AWB number
  const [isEditable, setIsEditable] = useState(canEditAwb);
  const [airportdata, setairportdata] = useState([]);
  const [spinner, loadSpinner] = useState(false);
  const [trackingawb, setTrackingawb] = useState("");
  const [awbError, setAwbError] = useState("");
  const [trackingAwbError, setTrackingAwbError] = useState("");
  // Exact message from the booking API's error response (e.g. "Payment has
  // not been confirmed for this query...") — shown inline above the Confirm
  // button so it doesn't rely on the toast alone.
  const [bookingApiError, setBookingApiError] = useState("");
  const [lattaoData, setLattoaData] = useState({});
  const [viewBreakupData, setviewBreakupData] = useState({});
  // { USD: <INR per 1 USD>, ... } — an ocean manual quote's charges can each
  // carry their own rateCurrency, so the Payment Summary's group/net totals
  // need these rates to convert everything to one INR figure.
  const [oceanExchangeRates, setOceanExchangeRates] = useState({});
  // One row per BL (count driven by "No. of BL") for the KAM ocean confirm
  // step — Bl_notable is controlled off this so the rows can go out with the
  // confirm payload. [{ key, confirmationNumber, containerNumber, blNumber }]
  const [blRows, setBlRows] = useState([]);

  useEffect(() => {
    httpinstance
      .get("admin/getexchangerates")
      .then((res) => {
        const rows = res?.data?.data || [];
        const rates = {};
        rows.forEach((r) => {
          if (r?.currency) rates[r.currency] = Number(r.inrRate) || 0;
        });
        setOceanExchangeRates(rates);
      })
      .catch(() => {});
  }, []);

  // const [loading, setLoading] = useState(true);
  // console.log("hiyuii", selectedItem);
  const loginedUser = useSelector(authuser);
  const isKam = loginedUser?.userroles === "kam";

  const dispatch = useDispatch();
  // const state = useSelector(searchratestate);
  const state1 = useSelector(updateStoredSearch);
  // Origin airport list — only used for the `iataCass` fallback lookup inside
  // buildRateSearchPayload (the query itself usually already carries `cass`).
  const { originairports } = useSelector(searchratestate);
  // const queryiddata=useSelector(updatequeryid);

  // console.log(state, 'state')

  const { newsearchformdata, rqueryid, mannualsearchdata } =
    state1?.payload?.newsearchform;
  // const storedAwbNumber = useSelector(()=>state);
  const storedAwbNumber = useSelector(selectStoredAwbNumber);
  const storedBookingId = useSelector(selectStoredBookingId);

  const { searchquery } = newsearchformdata;
  // Ocean Cargo bookings collect an MBL (Master Bill of Lading) number here
  // instead of an AWB — otherwise this is the exact same confirm flow.
  const isOceanBooking =
    searchquery?.cargoType === "Ocean Cargo" ||
    nodeData1?.searchquery?.cargoType === "Ocean Cargo";
  // Logs the user's credit limit for this booking's mode once the page/modal is showing.
  useLogCreditLimit({
    enabled: !!(isOpen || pageMode),
    cargoType: isOceanBooking ? "Ocean Cargo" : undefined,
  });
  // The same keys the air rate search sends to /ratesearch/all, rebuilt flat so
  // they can be spread at the root of the air booking payloads below. Ocean is
  // excluded outright: its bookings go to ratesearch/create-ocean-booking and
  // kam/ocean-booking/confirm, whose payloads must stay exactly as they are.
  // The builder omits requestType / queryId / bookingId / airwaybillNumber /
  // booking_status, so every existing key on those payloads keeps winning.
  const rateSearchPayload = useMemo(
    () =>
      isOceanBooking
        ? {}
        : buildRateSearchPayload(newsearchformdata, {
            originairports,
            requestType: newsearchformdata?.requestType || requestTypeProp,
          }),
    [isOceanBooking, newsearchformdata, originairports, requestTypeProp],
  );
  // `selectedItem` for an ocean booking is the ocean_offer object built in
  // OceanCargoDetails.jsx (shape: { productOffer, productPrice: { charges } })
  // — it has none of the air-only rateDetails/flightItineraries fields, so
  // every ocean-specific display below reads from these instead.
  const oceanSchedule = nodeData1?.ocean_schedule || {};
  const oceanSearchquery = nodeData1?.searchquery || {};
  const oceanSellCharges = isOceanBooking
    ? (selectedItem?.productPrice?.charges || []).filter(
        (c) => c.rateType === "SELL",
      )
    : [];
  const OCEAN_CURRENCY_SYMBOLS = { INR: "₹", USD: "$", EUR: "€", GBP: "£" };
  // A manual quote's charges carry their own `rateCurrency` (whatever the
  // KAM entered it in — INR, USD, ...), not always INR — formatrates()
  // hardcodes a ₹ regardless, so this panel needs its own symbol-aware
  // formatter instead.
  const formatOceanAmount = (amount, currency) => {
    const code = currency || "INR";
    const symbol = OCEAN_CURRENCY_SYMBOLS[code] || `${code} `;
    return `${symbol} ${Number(amount || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };
  // Converts an amount from its own currency to INR using the admin-
  // configured exchange rates (oceanExchangeRates, from admin/getexchangerates
  // — the same dynamic source used everywhere else in this file). If that
  // currency has no rate configured yet (e.g. EUR hasn't been added on the
  // Exchange Rate admin page), fall back to the charge's own `amountUsd` —
  // already correctly converted at quote time regardless of native currency
  // — times the admin-configured USD→INR rate, instead of silently treating
  // the raw native-currency number as if it were already INR (which is what
  // produced a "Destination Charges ₹310.00" total for what was actually
  // €310). Only if neither a native rate nor a usable amountUsd exists does
  // this fall back to the raw number, same as before.
  const toOceanInr = (amount, currency, amountUsd) => {
    const n = Number(amount) || 0;
    const code = currency || "INR";
    if (code === "INR") return n;
    const rate = Number(oceanExchangeRates?.[code]) || 0;
    if (rate > 0) return n * rate;
    const usdRate = Number(oceanExchangeRates?.USD) || 0;
    const usd = Number(amountUsd) || 0;
    return usdRate > 0 && usd > 0 ? usd * usdRate : n;
  };
  // Charges within a group (or across groups, for the grand total) aren't
  // guaranteed to share one currency — convert every charge to INR before
  // summing, so the group/net totals shown are one real figure rather than
  // raw numbers added across different currencies.
  const formatOceanTotalInr = (charges) => {
    const total = (charges || []).reduce(
      (sum, c) =>
        sum + toOceanInr(Number(c.amount ?? c.amountUsd) || 0, c.rateCurrency, c.amountUsd),
      0,
    );
    return formatOceanAmount(total, "INR");
  };
  const oceanGrandTotalInr = formatOceanTotalInr(oceanSellCharges);
  // The live recompute above converts every charge to INR using TODAY's
  // admin-configured exchange rates (oceanExchangeRates, fetched fresh on
  // mount) — if rates have moved since this booking was quoted/created, that
  // total drifts from the one actually charged, which OceanCargoDetails.jsx's
  // own "TOTAL RATE (INR)" reads straight off the persisted
  // nodeData.total_amount (see its totalInr). Prefer that same persisted
  // figure here so the KAM's Net Amount matches what the customer/booking
  // record already show; only fall back to the live recompute when no
  // persisted total exists yet (e.g. a fresh, not-yet-booked preview).
  const oceanPersistedTotalInr = Number(nodeData1?.total_amount) || 0;
  const oceanNetAmountInr =
    oceanPersistedTotalInr > 0
      ? formatOceanAmount(oceanPersistedTotalInr, "INR")
      : oceanGrandTotalInr;
  // GST split (freight taxed at 5%, everything else at 18%) is computed once
  // at booking time in OceanMainRateCom.jsx's confirmBooking and persisted on
  // the booking record as taxable_inr_amount/gst_inr_amount — read those
  // straight rather than recomputing, and only show the rows below when a
  // GST amount is actually present, so a booking made before this feature
  // existed renders exactly as it did before (no stray ₹0 GST row).
  // single_booking_data nests these under bookeditem (see chargeAmounts in
  // OceanMainRateCom.jsx's confirmBooking); fall back to the top level for
  // an offer that hasn't been persisted yet (e.g. still in the booking modal).
  const oceanGstInr = Number(nodeData1?.bookeditem?.gst_inr_amount ?? nodeData1?.gst_inr_amount) || 0;
  const oceanTaxableInr = Number(nodeData1?.bookeditem?.taxable_inr_amount ?? nodeData1?.taxable_inr_amount) || 0;
  const oceanGstUsd = Number(nodeData1?.bookeditem?.gst_usd_amount ?? nodeData1?.gst_usd_amount) || 0;
  const oceanTaxableUsd = Number(nodeData1?.bookeditem?.taxable_usd_amount ?? nodeData1?.taxable_usd_amount) || 0;
  // Same persisted-first precedence as oceanPersistedTotalInr above, so the
  // Net Amount row's USD figure matches the INR one instead of drifting from
  // a live recompute; taxable+GST is the last-resort fallback for a fresh,
  // not-yet-booked preview where no usd_amount has been persisted yet.
  const oceanNetAmountUsd =
    Number(nodeData1?.usd_amount ?? nodeData1?.bookeditem?.usd_amount) ||
    oceanTaxableUsd + oceanGstUsd;
  // Same precedence OceanCargoDetails.jsx uses for `commodityName`: prefer
  // the top-level booking field (always populated) over the nested
  // search_query_data snapshot, which can be absent (e.g. no saved search
  // query for this booking) and would otherwise show 0 containers/0 KG.
  // `oceanSearchquery.containerDetails` itself can be either shape: a nested
  // `{ containerDetails: [...] }` (ShipmentRateForm's search payload) or a
  // flat `[{ type, quantity, kgs }]` array (a manual-quote booking's
  // search_query_data is the raw admin Query document, which stores it flat —
  // see OceanCargoDetails.jsx's containerLineItems for the same fallback).
  const oceanContainerItems = Array.isArray(nodeData1?.containerDetails)
    ? nodeData1.containerDetails
    : Array.isArray(oceanSearchquery?.containerDetails)
      ? oceanSearchquery.containerDetails
      : oceanSearchquery?.containerDetails?.containerDetails || [];
  // Container-wise breakdown for the Payment Summary — built exactly as
  // OceanCargoDetails.jsx's containerBreakdown, so both panels agree.
  const oceanOfferRequested = selectedItem?.productPrice?.requestedContainers;
  const oceanContainerBreakdown = groupChargesByContainer(
    chargeLinesFromCharges(
      oceanSellCharges.map((c) => ({
        ...c,
        amount: Number(c.amountUsd ?? c.amount) || 0,
      })),
    ),
    oceanOfferRequested && oceanOfferRequested.length > 0
      ? oceanOfferRequested
      : oceanContainerItems.map((c) => ({
          type: c.type,
          qty: Number(c.quantity ?? c.qty) || 1,
          weightKg: containerLineWeight(c),
        })),
  );
  // USD → INR from the persisted taxable pair, else the persisted total pair
  // (same precedence as OceanCargoDetails.jsx's usdToInrRate), else today's
  // admin rate for a not-yet-booked preview.
  const oceanUsdToInr =
    oceanTaxableUsd > 0 && oceanTaxableInr > 0
      ? oceanTaxableInr / oceanTaxableUsd
      : oceanNetAmountUsd > 0 && oceanPersistedTotalInr > 0
        ? oceanPersistedTotalInr / oceanNetAmountUsd
        : Number(oceanExchangeRates?.USD) || null;
  // "$ 1,234.00 (₹ 1,02,000.00)"
  const formatOceanUsdInr = (amt) => (
    <>
      {formatOceanAmount(amt, "USD")}
      {oceanUsdToInr != null && (
        <span style={{ fontWeight: 500, color: "#9CA3AF", marginLeft: 4 }}>
          ({formatOceanAmount(amt * oceanUsdToInr, "INR")})
        </span>
      )}
    </>
  );
  // Taxable / GST / Net rows: "$ 9,266.77 (₹ 8,96,838.00)", or INR alone
  // when no USD figure was persisted.
  const formatOceanUsdThenInr = (usdAmt, inrText) =>
    usdAmt > 0 ? (
      <>
        {formatOceanAmount(usdAmt, "USD")}
        <span className="font-semibold opacity-70 ml-1">({inrText})</span>
      </>
    ) : (
      inrText
    );
  const oceanTotalContainers = oceanContainerItems.reduce(
    (s, c) => s + (Number(c?.quantity) || 0),
    0,
  );
  // kgs is the line total (legacy rows without weightType are per container).
  const oceanTotalKgs = totalContainerWeight(oceanContainerItems);
  // "2x 20GP, 1x 40HC" — Goods Description shows this instead of CBM/CFT for
  // ocean bookings, since volume isn't how FCL cargo is described.
  const oceanContainerTypeLabel = oceanContainerItems.length
    ? oceanContainerItems
        .map((c) => `${c?.quantity ?? ""}x ${c?.type ?? ""}`.trim())
        .join(", ")
    : "N/A";
  // `Noofbl` on `nodeData.search_query_data` (= oceanSearchquery here) can be
  // stale/null on a confirmed booking's snapshot even when it was set on the
  // query — confirmed against a real single_booking_data response where
  // search_query_data.Noofbl was null but queryData.Noofbl (the live query
  // record, also spread onto nodeData1) was 3. Prefer that.
  // Every ocean shipment has at least one master B/L, so an older record that
  // stored neither reads as 1 (the same default the search form now applies).
  // Counts are persisted as strings, so compare numerically — a stored "0"
  // is truthy and would otherwise render as a zero B/L count.
  const oceanNoOfBl =
    [nodeData1?.queryData?.Noofbl, oceanSearchquery?.Noofbl]
      .map(Number)
      .find((n) => n > 0) ?? 1;
  /**
   * Pulls the 3-letter IATA code out of a display string like
   * "Mumbai (BOM)". Returns "" when no parenthesised code is present.
   * @param {string} str - airport display label
   * @returns {string} the code inside parentheses, or empty string
   */
  function extractAirportCode(str) {
    const match = str?.match(/\(([^)]+)\)/);
    return match ? match[1] : "";
  }
  const or = extractAirportCode(
    searchquery?.originAirport?.originAirport
      ? searchquery?.originAirport?.originAirport
      : mannualsearchdata?.originPort?.originAirport,
  );
  const des = extractAirportCode(
    searchquery?.destinationAirport?.destinationAirport
      ? searchquery?.destinationAirport?.destinationAirport
      : mannualsearchdata?.destinationPort?.destinationAirport,
  );
  // Payload for the LAT/TAO lookup (Latest Acceptance Time / Time Of
  // Availability) — these cut-off times depend on the route, operation type
  // (e.g. import/export) and any special handling codes for the cargo.
  const lattaopayload = {
    origin: or,
    destination: des,
    operation_type: selectedItem?.flightItineraries?.[0]?.operationType,
    special_handling_code:
      newsearchformdata?.specialHandlingCodes ||
      newsearchformdata?.searchquery?.goodsDetails?.specialHandlingCodes,
  };
  // console.log(props, "props");

  // console.log(lattaopayload, "lattaopayload");

  const lattaoapicall = (lattaopayload) => {
    dispatch(lattao(lattaopayload))
      .then((res) => {
        // console.log(res, "lattao");
        setLattoaData(res?.payload?.data);
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    if (storedAwbNumber) {
      setAwbNumber(String(storedAwbNumber));
      setIsEditable(false);
    }
  }, [storedAwbNumber]);
  useEffect(() => {
    lattaoapicall(lattaopayload);
  }, [!selectedItem?.lat, !selectedItem?.tao]);
  useEffect(() => {
    if (
      nodeData1?.searchquery?.airlinepayloadData?.requestType == "2" ||
      props?.requestType == "2"
    ) {
      const query = queryidofflinepayment
        ? queryidofflinepayment?.queryId
        : props?.queryId
          ? props?.queryId
          : nodeData1?.searchquery?.airlinepayloadData?.queryId;
      dispatch(getsinglebookingdata({ queryId: query }))
        .then((res) => {})
        .catch((err) => {
          console.error(err);
        });
    }
  }, [nodeData1, props]);
  /**
   * Fetches the itemised charge breakup (freight, pickup/delivery, origin,
   * destination and VAS charges) for the selected rate and stores it in
   * `viewBreakupData`. Pickup/delivery charges are only requested when the
   * search query opted into door pickup/delivery.
   * @param {object} option - the selected rate item (provides freightCharges)
   */
  const checkViewBreakuUp = async (option) => {
    // console.log("option", option);
    // const params = {
    //   origin: option?.origin,
    //   destination: option?.destination,
    //   freightCharges: option?.rateDetails?.freightCharges,
    // };

    const params = {
      origin: or,
      destination: des,
      incoTerms: searchquery?.paymentTerms?.incoTerms,
      optionalVas:
        searchquery?.paymentTerms?.optionalVas?.map((item) => item.vatId) || [],
      totalWeight: searchquery?.packagingDetails?.shipmentTotal?.totalweight,
      freightCharges: option?.rateDetails?.freightCharges,
    };
    if (searchquery?.originAirport?.originPickup) {
      params.pickupCharges = option?.rateDetails?.pickupCharges;
    }
    if (searchquery?.destinationAirport?.destinationPickup) {
      params.deliveryCharges = option?.rateDetails?.deliveryCharges;
    }
    if (rqueryid !== undefined) {
      params.queryid = rqueryid;
    }
    // console.log(params, "params");
    // console.log(nodeData1, "paramsnodeData1******");
    // if(originPickup){
    //  params.pickupCharges = option?.rateDetails?.pickupCharges
    // }
    // if(destinationPickup){
    //  params.deliveryCharges = option?.rateDetails?.deliveryCharges
    // }

    // if (nodeData1?.nodeData?.queryid != undefined) {
    //   params.queryid = nodeData1?.nodeData?.queryid;
    // }
    // console.log("option", option);
    try {
      const response = await dispatch(viewBreakUp(params));
      setviewBreakupData(response?.payload.data?.data);
      // console.log("hiy",response?.payload.data?.data);
    } catch (err) {}
  };

  useEffect(() => {
    dispatch(airport_list())
      .then((res) => {
        const list = res?.payload?.data?.data;
        setairportdata(Array.isArray(list) ? list : []);
      })
      .catch((err) => console.error(err)); // Example payload
    // if (nodeData?.tracking_awb) {
    //   setIsEditable(false);
    // }
    // if (nodeData?.awb_number) {
    //   setIsEditable(false);
    // }

    checkViewBreakuUp(selectedItem);
  }, []);

  const getAirportNameByCode = (code) => {
    const airport = (airportdata || []).find((airport) => airport?.code === code);
    // console.log(code,airport,airportdata,"test")
    return airport ? airport.name : "Not Found";
  };
  // console.log(nodeData, "nodeData");
  /**
   * AWB/MBL number input handler. AWB (Air) numbers are numeric-only and
   * validated as exactly 8 digits; MBL (Ocean) numbers vary by carrier, so
   * they're accepted as free-form alphanumeric text as long as they're
   * non-empty.
   * @param {React.ChangeEvent<HTMLInputElement>} e
   */
  const handleInputChange = (e) => {
    const value = isOceanBooking
      ? e.target.value
      : e.target.value.replace(/\D/g, "");
    if (isEditable) {
      setAwbNumber(value);
    }
    if (isOceanBooking) {
      setAwbError(value ? "" : "MBL number cannot be empty");
    } else if (!value) {
      setAwbError("AWB number cannot be empty");
    } else if (value.length !== 8) {
      setAwbError("AWB number must be exactly 8 characters long");
    } else {
      setAwbError(""); // Clear error if valid
    }
  };
  const handletrackingawb = (e) => {
    const value = e.target.value;
    setTrackingawb(e.target.value);
    // Validation: Tracking AWB should not be empty
    if (!value) {
      setTrackingAwbError("Tracking AWB number cannot be empty");
    } else if (value.length !== 8) {
      setTrackingAwbError(
        "Tracking AWB number must be exactly 8 characters long",
      );
    } else {
      setTrackingAwbError(""); // Clear error if valid
    }
  };

  // Function to generate a dummy AWB number
  // const generateAWB = () => {
  //   const dummyAWB = `AWB-${Math.floor(100000 + Math.random() * 900000)}`; // Generates a random 6-digit AWB number
  //   setAwbNumber(dummyAWB);
  //   setIsEditable(false); // Make input non-editable
  // };
  /**
   * Formats a duration given in minutes as a "H hr M min" string.
   * @param {number} minutes - total minutes (0 is valid)
   * @returns {string} e.g. "2 hr 15 min", or "N/A" when minutes is missing
   */
  function MinutesToHours(minutes) {
    if (!minutes && minutes !== 0) return "N/A";
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours} hr ${mins} min`;
  }

  /**
   * Air Net Amount = sum of chargesBreakDown, plus the fallback GST when GST
   * was persisted only as rateDetails.gstAmount (no "GST" line item) — the
   * same case renderPaymentBreakdown shows the fallback GST rows for. Without
   * this the footer equals the Taxable Amount and drops the GST.
   */
  const getAirNetAmount = () => {
    const rateDetails = selectedItem?.rateDetails;
    const breakdown = rateDetails?.chargesBreakDown;
    if (!(breakdown?.length > 0)) {
      // No breakdown to sum — prefer the persisted GST-inclusive totalAmount;
      // freightCharges is a last-resort for very old records.
      return Number(rateDetails?.totalAmount ?? rateDetails?.freightCharges) || 0;
    }
    const chargesTotal = breakdown.reduce(
      (sum, c) =>
        sum + (Number(c.Totalamount ?? c.totalAmount ?? c.chargeAmount ?? 0) || 0),
      0,
    );
    const hasGstLineItem = breakdown.some(
      (c) => (c.category || c.chargeType) === "GST",
    );
    const fallbackGst = hasGstLineItem ? 0 : Number(rateDetails?.gstAmount) || 0;
    if (fallbackGst > 0) {
      // Use the same Taxable figure the fallback row displays, so the footer
      // always equals Taxable + GST (for non-itemised rate sources checkout
      // takes Taxable from rateDetails.totalAmount, not the breakdown sum).
      const taxable = Number(rateDetails?.taxableAmount) || chargesTotal;
      return taxable + fallbackGst;
    }
    return chargesTotal;
  };

  /**
   * Builds the list of JSX rows for the Payment Summary panel. Charges from
   * `rateDetails.chargesBreakDown` are grouped by category (Air Freight is
   * always expanded; other groups are collapsible), then any additional
   * pickup/delivery/origin/destination/VAS charges from the view-breakup API
   * are appended. Falls back to a single per-kg rate row when no breakdown exists.
   *
   * GST handling: if a "GST" category group is present (added at checkout —
   * see NewBookingFlowContent.jsx), a "Taxable Amount" divider row is
   * inserted immediately before it, showing the sum of every other group.
   * This reconstructs the Taxable Amount / GST Amount / Net Amount split
   * purely from chargesBreakDown, with no separate GST field to read. When
   * there's no GST group, no divider is inserted and this function's output
   * is identical to before GST existed.
   *
   * @returns {JSX.Element[]} rows to render inside the payment summary
   */
  const renderPaymentBreakdown = () => {
    if (isOceanBooking) {
      if (oceanContainerBreakdown.priced.length === 0) {
        return [
          <div key="ocean-rate" className="flex justify-between">
            <span className="text-sm text-gray-500">Ocean Freight</span>
            <span className="text-sm text-gray-800">N/A</span>
          </div>,
        ];
      }
      // Same container-wise Charge Breakdown as the booking-detail page
      // (OceanCargoDetails.jsx): Origin → Freight → Destination cards, one
      // collapsible row per container. Amounts are swapped for their USD
      // value so every subtotal sums in one currency.
      return [
        <OceanContainerChargeBreakdown
          key="ocean-breakdown"
          breakdown={oceanContainerBreakdown}
          formatAmount={formatOceanUsdInr}
        />,
      ];
    }

    const breakdown = selectedItem?.rateDetails?.chargesBreakDown;
    const items = [];

    // Charges may arrive in two shapes:
    //   old: { category, name, Totalamount/totalAmount, ratePerkilo }
    //   new: { chargeType, chargeCode, chargeDescription, chargeAmount }
    // Normalize field access so both render the same way.
    const chargeGroup = (c) => c.category || c.chargeType || "Other";
    const chargeName = (c) =>
      c.name || c.chargeDescription || c.chargeCode || chargeGroup(c);
    const chargeAmt = (c) =>
      Number(c.Totalamount ?? c.totalAmount ?? c.chargeAmount ?? 0) || 0;

    const hasBreakdownOrigin = breakdown?.some(
      (c) => chargeGroup(c) === "Origin Charges",
    );
    const hasBreakdownDest = breakdown?.some(
      (c) => chargeGroup(c) === "Destination Charges",
    );

    const categoryDisplayName = (cat) => {
      if (cat === "Main" || cat === "Freight Charges") return "Air Freight";
      if (cat === "Other taxes") return "Other Fees";
      return cat;
    };

    if (breakdown?.length > 0) {
      const groups = breakdown.reduce((acc, charge) => {
        const key = chargeGroup(charge);
        if (!acc[key]) acc[key] = [];
        acc[key].push(charge);
        return acc;
      }, {});

      // Taxable Amount — sum of every non-GST group, shown as its own line
      // right before the GST card. Bookings with no GST group (older records,
      // or rates where GST doesn't apply) never trigger this — items.length
      // and the Total Amount/Net Amount footer stay exactly as before.
      const preGstSubtotal = Object.entries(groups)
        .filter(([groupName]) => groupName !== "GST")
        .reduce(
          (s, [, charges]) => s + charges.reduce((ss, c) => ss + chargeAmt(c), 0),
          0,
        );

      // Same visual language as the KAM/customer Booking Details pages
      // (BookingDetailPage.jsx): every group is
      // an always-expanded border-l-4 card, colour assigned by rotating
      // through CHARGE_COLORS rather than hardcoding one colour per category
      // name — new categories just pick up the next colour in the rotation.
      Object.entries(groups).forEach(([groupName, charges], groupIdx) => {
        const groupTotal = charges.reduce(
          (sum, c) => sum + chargeAmt(c),
          0,
        );
        const style = CHARGE_COLORS[groupIdx % CHARGE_COLORS.length];

        if (groupName === "GST") {
          items.push(
            <div
              key="taxable-amount"
              className="mt-1 border-l-4 border-amber-300 rounded-r-lg overflow-hidden"
            >
              <div className="flex items-center justify-between py-2 px-3 bg-amber-50">
                <span className="text-xs font-bold text-amber-700 uppercase tracking-wider">
                  Taxable Amount
                </span>
                <span className="text-sm font-bold text-amber-700">
                  {formatrates(preGstSubtotal.toFixed(2))}
                </span>
              </div>
            </div>,
          );
        }

        items.push(
          <div key={groupName} className={`border-l-4 ${style.border} rounded-r-lg overflow-hidden`}>
            <div className={`flex justify-between items-center py-2 px-3 ${style.headerBg}`}>
              <span className={`text-sm font-bold ${style.nameText}`}>
                {categoryDisplayName(groupName)}
              </span>
              <span className={`text-sm font-bold ${style.totalText}`}>
                {formatrates(groupTotal.toFixed(2))}
              </span>
            </div>
            <div className="divide-y divide-gray-100">
              {charges.map((charge, idx) => {
                // Base rate/freight + markup breakup is only shown for the
                // freight (Main) group, and only when those fields exist.
                const isFreightGroup =
                  groupName === "Main" || groupName === "Freight Charges";
                const baseRatePerKg = Number(charge.Baserateperkg) || 0;
                const baseFreight = Number(charge.Basefreight) || 0;
                const explicitMarkupPct =
                  Number(
                    charge.markupPercentage ??
                      selectedItem?.markupResult?.markup,
                  ) || 0;
                // Markup amount = base freight × percentage. When no explicit
                // percentage arrives, fall back to (total − base freight) and
                // derive the percentage from it so the amount always shows.
                const markupAmount =
                  explicitMarkupPct > 0
                    ? (baseFreight * explicitMarkupPct) / 100
                    : Math.max(chargeAmt(charge) - baseFreight, 0);
                const markupPct =
                  explicitMarkupPct > 0
                    ? explicitMarkupPct
                    : baseFreight > 0
                      ? (markupAmount / baseFreight) * 100
                      : 0;
                const showFreightBreakup =
                  isFreightGroup && (baseRatePerKg > 0 || baseFreight > 0);

                return (
                  <div key={idx} className="px-3 py-2">
                    <div className="flex justify-between items-start">
                      <div>
                        <span className="text-xs text-gray-600">
                          {chargeName(charge)}
                        </span>
                        {charge.ratePerkilo > 0 && !showFreightBreakup && (
                          <p className="text-xs text-gray-400">
                            {formatrates(charge.ratePerkilo.toFixed(2))}/kg
                          </p>
                        )}
                      </div>
                      <span className={`text-xs font-medium ${style.totalText}`}>
                        {formatrates(chargeAmt(charge).toFixed(2))}
                      </span>
                    </div>

                    {showFreightBreakup && (
                      <div className="mt-1.5 pl-3 border-l border-gray-200 space-y-1">
                        {baseFreight > 0 && (
                          <div className="flex justify-between items-center">
                            <span className="text-[11px] text-gray-400">
                              Base freight
                            </span>
                            <span className="text-[11px] text-gray-500">
                              {formatrates(baseFreight.toFixed(2))}
                            </span>
                          </div>
                        )}
                        {markupPct > 0 && (
                          <div className="flex justify-between items-center">
                            <span className="text-[11px] text-gray-400">
                              Markup ({Number(markupPct.toFixed(2))}%)
                            </span>
                            <span className="text-[11px] text-gray-500">
                              {formatrates(markupAmount.toFixed(2))}
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>,
        );
      });
    } else {
      items.push(
        <div key="rate" className="flex justify-between">
          <span className="text-sm text-gray-500">Airfreight Rate</span>
          <span className="text-sm text-gray-800">
            {formatrates(
              selectedItem?.rateDetails?.ratePerkilo?.toFixed(2),
            ) + "/kg"}
          </span>
        </div>,
      );
    }

    // GST fallback for bookings with no "GST" category charge — e.g. a
    // hasBreakdown=false booking (QR/direct-airline rate, or an empty
    // chargesBreakDown) where GST was calculated at checkout but never
    // appended as its own chargesBreakDown line item. NewBookingFlowContent.jsx
    // still persists the split as plain rateDetails.taxableAmount/gstAmount
    // fields, so we can show it here without touching chargesBreakDown at all.
    // Bookings made before GST existed simply have no gstAmount field, so
    // this fallback never fires for them and they render unchanged.
    const hasGstLineItem = breakdown?.some((c) => chargeGroup(c) === "GST");
    const fallbackGstAmount = Number(selectedItem?.rateDetails?.gstAmount) || 0;
    if (!hasGstLineItem && fallbackGstAmount > 0) {
      const fallbackTaxableAmount =
        Number(selectedItem?.rateDetails?.taxableAmount) || 0;
      // Match the surrounding rows' style: when `breakdown` has other groups,
      // those render as border-l-4 cards (see the "if/else" above), so these
      // two rows use the same card style to align. When there's no breakdown
      // at all, the sibling rows below (Airfreight Rate, Pickup Charges, …)
      // are plain unboxed "flex justify-between" text with no left padding —
      // a border-l-4 card here would sit 16px further right than them, so we
      // use the -mx-4/px-4 bleed trick instead to keep the text flush.
      const inBoxedContext = breakdown?.length > 0;
      items.push(
        <div
          key="taxable-amount-fallback"
          className={
            inBoxedContext
              ? "mt-1 border-l-4 border-amber-300 rounded-r-lg overflow-hidden"
              : "-mx-4 px-4 mt-1 py-2 bg-amber-50"
          }
        >
          <div className={inBoxedContext ? "flex items-center justify-between py-2 px-3 bg-amber-50" : "flex items-center justify-between"}>
            <span className="text-xs font-bold text-amber-700 uppercase tracking-wider">
              Taxable Amount
            </span>
            <span className="text-sm font-bold text-amber-700">
              {formatrates(fallbackTaxableAmount.toFixed(2))}
            </span>
          </div>
        </div>,
      );
      items.push(
        <div
          key="gst-fallback"
          className={inBoxedContext ? "border-l-4 border-teal-400 rounded-r-lg overflow-hidden" : "-mx-4 px-4 bg-teal-50"}
        >
          <div className={inBoxedContext ? "flex justify-between items-center py-2 px-3 bg-teal-50" : "flex justify-between items-center py-3"}>
            <span className="text-sm font-bold text-teal-800">
              GST Amount (18%)
            </span>
            <span className="text-sm font-bold text-teal-600">
              {formatrates(fallbackGstAmount.toFixed(2))}
            </span>
          </div>
        </div>,
      );
    }

    if (viewBreakupData?.pickupCharges > 0) {
      items.push(
        <div key="pickup" className="flex justify-between">
          <span className="text-sm text-gray-500">Pickup Charges</span>
          <span className="text-sm text-gray-800">
            {formatrates(viewBreakupData.pickupCharges.toFixed(2))}
          </span>
        </div>,
      );
    }
    if (viewBreakupData?.deliveryCharges > 0) {
      items.push(
        <div key="delivery" className="flex justify-between">
          <span className="text-sm text-gray-500">Delivery Charges</span>
          <span className="text-sm text-gray-800">
            {formatrates(viewBreakupData.deliveryCharges.toFixed(2))}
          </span>
        </div>,
      );
    }
    if (viewBreakupData?.OriginCharges > 0 && !hasBreakdownOrigin) {
      items.push(
        <div key="originBreakup" className="flex justify-between">
          <span className="text-sm text-gray-500">Origin Charges</span>
          <span className="text-sm text-gray-800">
            {formatrates(viewBreakupData.OriginCharges.toFixed(2))}
          </span>
        </div>,
      );
    }
    if (viewBreakupData?.DestinationCharges > 0 && !hasBreakdownDest) {
      items.push(
        <div key="destBreakup" className="flex justify-between">
          <span className="text-sm text-gray-500">Destination Charges</span>
          <span className="text-sm text-gray-800">
            {formatrates(viewBreakupData.DestinationCharges.toFixed(2))}
          </span>
        </div>,
      );
    }
    if (viewBreakupData?.vas > 0) {
      items.push(
        <div key="vas" className="flex justify-between">
          <span className="text-sm text-gray-500">VAS Charges</span>
          <span className="text-sm text-gray-800">
            {formatrates(viewBreakupData.vas.toFixed(2))}
          </span>
        </div>,
      );
    }

    return items;
  };

  // const data = nodeData?.shipmentDimensions;//december chnages
  // console.log(data, "data789");
  const data =
    newsearchformdata?.searchquery?.packagingDetails?.packagingType?.packages ||
    nodeData1?.searchquery?.packagingDetails?.packagingType?.packages ||
    selectedItem?.shipmentDimensions ||
    [];
  /**
   * Sums the volumetric (dimensional) weight across all package rows.
   * @param {Array} data - package rows with pieces and L/W/H in centimetres
   * @returns {number} total volumetric weight in KG
   */
  function calculateTotalVolumeWeight(data) {
    return data?.reduce((total, item) => {
      // IATA volumetric-weight rule for cm dimensions: (L×W×H in cm³) / 6000
      // gives the chargeable weight in KG for each line, multiplied by pieces.
      const volumeWeight =
        (item.numberOfPieces * item.length * item.width * item.height) / 6000;
      return total + volumeWeight;
    }, 0);
  }
  const totalVolWeight = calculateTotalVolumeWeight(data);

  const originFlag =
    searchquery?.originAirport?.originLogoUrl ||
    mannualsearchdata?.originPort?.originLogoUrl ||
    "";
  const destinationFlag =
    searchquery?.destinationAirport?.destinationLogoUrl ||
    mannualsearchdata?.destinationPort?.destinationLogoUrl ||
    "";
  // ── CM vs IN vol-weight — compute from totalvolume + unit ─────────────────
  // Payload may not contain a pre-computed volumeWeight field, so derive it:
  //   CM (CBM): volWeight = CBM × 166.67
  //   IN (CFT): totalvolume is CFT → convert to CBM first, then × 166.67
  // Falls back to the stored volumeWeight field if totalvolume is absent.
  // Prefer the fresh form payload (newsearchformdata) — same precedence as
  // `data` above — so the form's exact stored totalvolweight is used instead of
  // re-deriving from CFT, which over-counts by ~1% (e.g. 133.09 vs 134.48).
  const _shipTotalNode =
    newsearchformdata?.searchquery?.packagingDetails?.shipmentTotal ||
    nodeData1?.searchquery?.packagingDetails?.shipmentTotal;
  const _rawVol   = _shipTotalNode?.totalvolume;
  const _volUnit  = _shipTotalNode?.unit || "CBM";
  // Prefer stored totalvolweight (exact, matches form's rounded-cm calculation).
  // Falls back to formula-derived value for older records without the field.
  const _storedVWNode = _shipTotalNode?.totalvolweight;
  // Guard: > 0 so a stored 0 (empty-form init) falls through to the fallback.
  const volumeWeightDisplay = _storedVWNode != null && parseFloat(_storedVWNode) > 0
    ? parseFloat(_storedVWNode)
    : _rawVol
      ? _volUnit === "CFT"
        ? parseFloat(_rawVol) * 0.0283168 * 166.67
        : parseFloat(_rawVol) * 166.67
      : _shipTotalNode?.volumeWeight;
  // ─────────────────────────────────────────────────────────────────────────

  // derived vol-unit helper used by both Goods Description instances below
  const _nodeVolUnit = _volUnit;

  // ── Commodity + temperature range (air) ──────────────────────────────────
  // Both are already on the single_booking_data response the page fetched
  // (search_query_data.goodsDetails.commodity_description = "Fats and oils
  // (Perishables)", search_query_data.temperatureRange = "2-8"), so they're
  // read straight off it — no commodity-service lookup. The shared resolvers
  // are the same ones the booking-detail pages use: they probe
  // search_query_data / searchquery / root because the fields sit at different
  // depths per booking age, and formatTemperatureRange turns the stored "2-8"
  // into "2°C to 8°C". newsearchformdata is only a fallback, for the live
  // booking flow that mounts this with no nodeData1 (BookingConfirmationPage).
  // Purely additive: the existing display expressions stay as the last resort,
  // and ocean keeps its own commodity mapping untouched.
  const resolvedCommodity =
    resolveStoredCommodity(nodeData1) || resolveStoredCommodity(newsearchformdata);
  // Empty for ambient cargo — the chip/row below is then omitted entirely
  // rather than painting an "N/A" temperature.
  const temperatureText =
    resolveTemperatureRange(nodeData1) ||
    resolveTemperatureRange(newsearchformdata);

  // ── Carrier commodity codes for the header chips / Goods Description ─────
  // Same source and precedence NewBookingFlowContent.jsx uses, so this page
  // and the customer booking flow describe the cargo identically: the
  // commodity master (`commodity-details/<commodityId>`) is the row the user
  // actually picked in the search form and carries the airline's codes for it
  // ({ commodityDescription: "Fats and oils (Perishables)", QR_commodityCode:
  // "9978", productCode: "QFR", commodityShc: "PER" }). The booking's own
  // productCommodityDetails stays the fallback for bookings whose commodityId
  // doesn't resolve (manual quotes, older stored searches), so nothing
  // regresses there. Air only — ocean has no such master.
  const [commodityMaster, setCommodityMaster] = useState(null);
  // The id sits at a different depth per booking age/entry point: a confirmed
  // booking carries it on the single_booking_data search-query snapshot, the
  // live flow only in the stored search.
  const commodityId =
    nodeData1?.search_query_data?.goodsDetails?.commodityId ||
    nodeData1?.searchquery?.goodsDetails?.commodityId ||
    newsearchformdata?.searchquery?.goodsDetails?.commodityId ||
    searchquery?.commodityId ||
    newsearchformdata?.commodityId;

  useEffect(() => {
    if (isOceanBooking || !commodityId) {
      setCommodityMaster(null);
      return;
    }
    httpinstance
      .get(`commodity-details/${commodityId}`)
      .then((res) => {
        // { id, hscode, commodityDescription, CommodityDescription,
        //   commodityGroup, commodityShc, QR_commodityCode, productCode }
        const record = res?.data?.data?.data;
        if (record) setCommodityMaster(record);
      })
      // A 404 for an unmapped id just leaves the fallbacks below in charge.
      .catch(() => {});
  }, [commodityId, isOceanBooking]);

  const bookedProductCommodity =
    resolveProductCommodityDetails(nodeData1) ||
    resolveProductCommodityDetails(selectedItem);
  // Nature of Goods = the commodity master's description, which is the
  // shipper-facing wording ("Fats and oils (Perishables)") rather than the
  // carrier block's coarse natureOfGoods ("PERISHABLE").
  const gdNatureOfGoods =
    commodityMaster?.commodityDescription ||
    resolvedCommodity ||
    bookedProductCommodity?.natureOfGoods ||
    "";
  const gdCommodityCode =
    commodityMaster?.QR_commodityCode ||
    bookedProductCommodity?.commodityCode ||
    "";
  const gdProductCode =
    commodityMaster?.productCode || bookedProductCommodity?.productCode || "";
  // commodityShc arrives as a single code or a comma-separated string ("PER",
  // "PER,COL"); the booking's product block carries an array instead.
  const gdShcList = (() => {
    const fromMaster = String(commodityMaster?.commodityShc ?? "")
      .split(",")
      .map((c) => c.trim().toUpperCase())
      .filter(Boolean);
    if (fromMaster.length) return [...new Set(fromMaster)];
    const fromBooking = bookedProductCommodity?.specialHandlingCodes;
    return Array.isArray(fromBooking)
      ? [
          ...new Set(
            fromBooking
              .map((c) => String(c).trim().toUpperCase())
              .filter(Boolean),
          ),
        ]
      : [];
  })();
  const gdShc = gdShcList.join(", ");
  // ─────────────────────────────────────────────────────────────────────────

  // ── LAT / TOA (Latest Acceptance Time / Time Of Availability) ────────────
  // A live rate offer carries these as bare numbers on `selectedItem`
  // (LAT/lat, TOA/tao), but a confirmed booking carries them on the
  // single_booking_data root as the already-formatted strings this file stamps
  // into the booking payload ("300 Mins" — see latValue/toaValue below), and
  // `selectedItem` there is `bookeditem`, whose lat/tao are null. So both are
  // probed, first usable value wins.
  /**
   * First value that reads as a positive duration, skipping null/""/0 — so a
   * blank on one source falls through to the next instead of stopping the chain.
   * @param {...*} vals - candidate LAT/TOA values, most-authoritative first
   * @returns {*} the first usable value, or undefined
   */
  const pickLatToa = (...vals) =>
    vals.find((v) => v != null && v !== "" && parseFloat(String(v)) > 0);
  /**
   * Formats a LAT/TOA value for display. `Number("300 Mins")` is NaN, so the
   * numeric part is parsed out for the >0 test, and the "Mins" suffix is only
   * appended when the value doesn't already carry a unit — otherwise a stored
   * booking's "300 Mins" failed the test and rendered "N/A".
   * @param {*} raw - LAT/TOA value from the offer or the booking
   * @returns {string} e.g. "300 Mins", or "N/A" when there's no usable value
   */
  const formatLatToa = (raw) => {
    if (raw == null || raw === "") return "N/A";
    const text = String(raw).trim();
    if (!(parseFloat(text) > 0)) return "N/A";
    // Already carries its unit ("300 Mins") — show as stored, don't double it.
    if (/[a-z]/i.test(text)) return text;
    return `${text}${itemRatesFrom === "QR" ? "" : " Mins"}`;
  };
  const latDisplay = formatLatToa(
    pickLatToa(
      selectedItem?.LAT,
      selectedItem?.lat,
      nodeData1?.LAT,
      nodeData1?.lat,
      nodeData1?.bookeditem?.LAT,
      nodeData1?.bookeditem?.lat,
    ),
  );
  const toaDisplay = formatLatToa(
    pickLatToa(
      selectedItem?.TOA,
      selectedItem?.tao,
      nodeData1?.TOA,
      nodeData1?.tao,
      nodeData1?.bookeditem?.TOA,
      nodeData1?.bookeditem?.tao,
    ),
  );

  //   console.log( nodeData,data34,nodeData?.shipmentQuantityDetails,nodeData?.calculatedType,"data45677")
  // console.log(nodeData,nodeData1,'nodeDatahi')
  //   const values = {
  //     queryId: props?.queryId ? props?.queryId : nodeData1?.searchquery?.airlinepayloadData?.queryId,
  //     bookingType: props?.requestType
  //       ? props?.requestType
  //       : nodeData1?.searchquery?.airlinepayloadData?.requestType,
  //     tracking_awb: trackingawb,

  //     bookingData: {
  //       carrier_type: 1,
  //       calculatedType: props?.calculatedType,
  //       lat: selectedItem?.lat ? selectedItem?.lat : lattaoData?.lat,
  //       tao: selectedItem?.tao ? selectedItem?.tao : lattaoData?.tao,

  //       // nodeData?.search_query_data?.airlinepayloadData
  //       //   ?.calculatedType
  //       //   ? nodeData?.search_query_data?.airlinepayloadData?.calculatedType
  //       //   : nodeData?.calculatedType,
  //       ailinelogoUrl:
  //         nodeData1?.airlineResponse[0]?.availabilityResponseSOs[0]
  //           ?.ailinelogoUrl,

  //       // getQPlusMode: nodeData?.getQPlusMode,
  //       optionalVas: nodeData1?.searchquery?.paymentTerms?.optionalVas
  //         ? nodeData1?.searchquery?.paymentTerms?.optionalVas
  //         : [],
  //       requestType: props?.requestType
  //         ? props?.requestType
  //         : props?.searchquery?.airlinepayloadData?.requestType,
  //       bookingId:          selectedItem?.flightItineraries[0]?.rates_from==="FS"?Number(bookingIdstate?.frieghtosbookingid):Number(bookingIdstate?.qrbookingid),          //  props?.bookingId ? props?.bookingId : nodeData1?.bookingId, //not present in nodedata1
  //       requestRefId: selectedItem?.requestRefId,
  //       airWaybillNumber: awbNumber,
  //       autoConfirm: selectedItem?.autoConfirm,
  //       origin: selectedItem?.origin,
  //       destination: selectedItem?.destination,
  //       flightItineraries: selectedItem?.flightItineraries,

  //       shipmentQuantityDetails: {
  //         chargeableWeight: selectedItem?.rateDetails?.chargeableWeight,
  //         chargeableWeightUnit: selectedItem?.rateDetails?.chargeableWeightUnit,
  //         totalPieces: selectedItem?.flightItineraries?.[0]?.pcs,
  //         totalVolume: selectedItem?.flightItineraries?.[0]?.volume,
  //         totalWeight: selectedItem?.flightItineraries?.[0]?.weight,
  //         volumeUnit:  props?.shipmentQuantityDetails?.volumeUnit ? props?.shipmentQuantityDetails?.volumeUnit :nodeData1?.shipmentQuantityDetails?.volumeUnit,
  //         weightUnit: props?.shipmentQuantityDetails?.weightUnit ? props?.shipmentQuantityDetails?.weightUnit :nodeData1?.shipmentQuantityDetails?.weightUnit,
  //         total_vol_wt: props?.shipmentQuantityDetails?.total_vol_wt ? props?.shipmentQuantityDetails?.total_vol_wt :nodeData1?.shipmentQuantityDetails?.total_vol_wt,
  //       },
  //       packagingType: props?.packagingType ? props?.packagingType : nodeData1?.searchquery?.packagingDetails,
  //       goodsDetails: props?.goodsDetails ? props?.goodsDetails : nodeData1?.searchquery?.goodsDetails,
  //       status: props?.status ? props?.status : nodeData1?.status, // not known
  //       // flightItineraries: selectedItem?.flightItineraries?.map((item) => ({
  //       //   carrierCode: item?.carrierCode,
  //       //   airlinePrefix: item?.airlinePrefix,
  //       //   carr_name: item?.carr_name,
  //       //   carrierNumber: item?.carrierNumber,
  //       //   scheduledArrivalDate: item?.scheduledArrivalDate,
  //       //   scheduledDepartureDate: item?.scheduledDepartureDate,
  //       //   segmentOfArrival: item?.segmentOfArrival,
  //       //   segmentOfDeparture: item?.segmentOfDeparture,
  //       //   carrierAircraftType: item?.carrierAircraftType,
  //       // })),

  //       shipmentDimensions:
  //       //  [
  //       //   {
  //       //     numberOfPieces: props?.shipmentDimensions?.[0]?.numberOfPieces ? props?.shipmentDimensions?.[0]?.numberOfPieces :nodeData1?.shipmentDimensions?.[0]?.numberOfPieces,
  //       //     length:  props?.shipmentDimensions?.[0]?.length ? props?.shipmentDimensions?.[0]?.length :nodeData1?.shipmentDimensions?.[0]?.length,
  //       //     width:props?.shipmentDimensions?.[0]?.width ? props?.shipmentDimensions?.[0]?.width : nodeData1?.shipmentDimensions?.[0]?.width,
  //       //     height: props?.shipmentDimensions?.[0]?.height ? props?.shipmentDimensions?.[0]?.height : nodeData1?.shipmentDimensions?.[0]?.height,
  //       //     dimensionsUnit: props?.shipmentDimensions?.[0]?.dimensionsUnit ? props?.shipmentDimensions?.[0]?.dimensionsUnit : nodeData1?.shipmentDimensions?.[0]?.dimensionsUnit,
  //       //     weightPerPiece: props?.shipmentDimensions?.[0]?.weightPerPiece ? props?.shipmentDimensions?.[0]?.weightPerPiece :nodeData1?.shipmentDimensions?.[0]?.weightPerPiece,
  //       //     weightUnit: props?.shipmentDimensions?.[0]?.weightUnit ? props?.shipmentDimensions?.[0]?.weightUnit : nodeData1?.shipmentDimensions?.[0]?.weightUnit,
  //       //     turnable: props?.shipmentDimensions?.[0]?.turnable ? props?.shipmentDimensions?.[0]?.turnable : nodeData1?.shipmentDimensions?.[0]?.turnable,
  //       //     stackable: props?.shipmentDimensions?.[0]?.stackable ? props?.shipmentDimensions?.[0]?.stackable : nodeData1?.shipmentDimensions?.[0]?.stackable,
  //       //     volumeWeight: nodeData1?.shipmentDimensions?.[0]?.volumeWeight,
  //       //   },
  //       // ]
  //       (selectedItem?.hash
  //   ? props?.shipmentDimensions
  //   : nodeData?.shipmentDimensions
  // )?.map((item, index) => ({
  //   numberOfPieces: item?.numberOfPieces,
  //   length: item?.length,
  //   width: item?.width,
  //   height: item?.height,
  //   dimensionsUnit: item?.dimensionsUnit,
  //   weightPerPiece: item?.weightPerPiece,
  //   weightUnit: item?.weightUnit,
  //   turnable: item?.turnable,
  //   stackable: item?.stackable,
  //   volumeWeight: selectedItem?.hash
  //     ? props?.shipmentDimensions?.[index]?.volumeWeight
  //     : nodeData1?.shipmentDimensions?.[index]?.volumeWeight,
  // }))
  //       ,

  //       productCommodityDetails: nodeData1?.productDetails,

  //       rateDetails: selectedItem?.rateDetails,
  //       travelTime: selectedItem?.travelTime,
  //       ratesFrom: selectedItem?.ratesFrom,
  //       embargoNotificationRemarks: selectedItem?.embargoNotificationRemarks,
  //       businessErrorSOs: selectedItem?.businessErrorSOs,
  //       allotmentItineraries: selectedItem?.allotmentItineraries,
  //       capacityAvailable: selectedItem?.capacityAvailable,
  //       queueOutcome: selectedItem?.queueOutcome,
  //     },
  //   };

  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
    // console.log("Selected:", event.target.value);
  };

  // const updatevalues = {
  //   queryId: nodeData?.queryId,
  //   bookingType: nodeData?.requestType,
  //   tracking_awb: trackingawb,
  //   bookingData: {
  //     calculatedType: nodeData?.calculatedType,
  //     // getQPlusMode: nodeData?.getQPlusMode,
  //     requestType: nodeData?.requestType,
  //     bookingId: nodeData?.bookingId,
  //     requestRefId: selectedItem?.requestRefId,
  //     airWaybillNumber: awbNumber,
  //     autoConfirm: selectedItem?.autoConfirm,
  //     origin: selectedItem?.origin,
  //     destination: selectedItem?.destination,
  //     // ratesFrom: selectedItem?.ratesFrom,
  //     flightItineraries: selectedItem?.flightItineraries,
  //     shipmentDimensions: [
  //       {
  //         dimensionsUnit: nodeData?.shipmentDimensions[0]?.dimensionsUnit,
  //         height: nodeData?.shipmentDimensions[0]?.height,
  //         length: nodeData?.shipmentDimensions[0]?.length,
  //         numberOfPieces: nodeData?.shipmentDimensions[0]?.numberOfPieces,
  //         stackable: nodeData?.shipmentDimensions[0]?.stackable,
  //         turnable: nodeData?.shipmentDimensions[0]?.turnable,
  //         weightPerPiece: nodeData?.shipmentDimensions[0]?.weightPerPiece,
  //         weightUnit: nodeData?.shipmentDimensions[0]?.weightUnit,
  //         width: nodeData?.shipmentDimensions[0]?.width,
  //       },
  //     ],
  //     shipmentQuantityDetails: {
  //       chargeableWeight: nodeData?.shipmentQuantityDetails?.chargeableWeight,
  //       chargeableWeightUnit:
  //         nodeData?.shipmentQuantityDetails?.chargeableWeightUnit,
  //       total_vol_wt: totalVolWeight,
  //       totalPieces: nodeData?.shipmentQuantityDetails?.totalPieces,
  //       totalVolume: nodeData?.shipmentQuantityDetails?.totalVolume,
  //       totalWeight: nodeData?.shipmentQuantityDetails?.totalWeight,
  //       volumeUnit: nodeData?.shipmentQuantityDetails?.volumeUnit,
  //       weightUnit: nodeData?.shipmentQuantityDetails?.weightUnit,
  //     },
  //     productCommodityDetails: {
  //       productCode: selectedItem?.productCommodityDetails?.productCode,
  //       commodityCode: selectedItem?.productCommodityDetails?.commodityCode,
  //       dgShipment: selectedItem?.productCommodityDetails?.dgShipment,

  //       specialHandlingCodes: [
  //         selectedItem?.productCommodityDetails?.specialHandlingCodes?.[0],
  //         ...(selectedValue === "EAP" || selectedValue === "EAW"
  //           ? [selectedValue]
  //           : []),
  //       ],
  //       densityGroup: selectedItem?.productCommodityDetails?.densityGroup,
  //       natureOfGoods: selectedItem?.productCommodityDetails?.natureOfGoods,
  //       serviceCode: selectedItem?.productCommodityDetails?.serviceCode,
  //     },
  //     rateDetails: selectedItem?.rateDetails,
  //     travelTime: selectedItem?.travelTime,
  //     ratesFrom: selectedItem?.ratesFrom,
  //   },
  // };
  // console.log(nodeData?.airlineResponse[0]?.availabilityResponseSOs[0]?.ailinelogoUrl,selectedItem,"nodeDatafypdata")

  // console.log(
  //   nodeData?.airWaybillNumber,
  //   nodeData?.tracking_awb,
  //   selectedItem?.travelTime,
  //   "hi"
  // );
  // console.log(nodeData1, "nodeData1", selectedItem, props,nodeData1?.searchquery?.airlinepayloadData?.queryId);
  /**
   * Requests a system-generated AWB number from the backend. On success the
   * number is placed in the input; on any failure a toast prompts the user to
   * enter an AWB manually so the booking can still proceed.
   */
  const handleGenerate = () => {
    dispatch(getawb())
      .then((res) => {
        // console.log(res, "res");
        if (res?.payload?.data?.statusCode === 200) {
          setAwbNumber(res?.payload?.data?.data);
          toast.success(
            res?.payload?.data?.message ||
              "AWB number generated successfully! You'll get the number once the shipment has been booked",

            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              // theme: "colored",
            },
          );
        } else {
          // console.log(res?.payload?.response?.data?.message, "res");
          toast.error(
            res?.payload?.response?.data?.message ||
              "AWB number cannot be generated currently, please provide a number to continue with the booking",
            {
              position: "top-center",
              autoClose: 2000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              // theme: "colored",
            },
          );
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(
          err?.payload?.response?.data?.message ||
            "AWB number cannot be generated currently, please provide a number to continue with the booking",
          {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            // theme: "colored",
          },
        );
      });
  };
  // console.log(finalupval, "finalupval");
  // const awbstatus = async(payload) => {

  //     try {
  //                    const response = await httpinstance.put('/awb/status', payload);
  //                   console.log(response, "awbstatus")
  //                  } catch (error) {
  //                   console.log(`Failed to blacklist: ${error?.message}`);
  //                  }
  // };
  const handleclick = () => {
    if (selectedValue) {
      // if (awbNumber.length === 0 && nodeData?.airWaybillNumber?.length === 0) {
      //   setAwbError("AWB Number is required");
      //   if (trackingawb.length === 0 && nodeData?.tracking_awb?.length === 0) {
      //     setTrackingAwbError("Tracking AWB Number is required");
      //     return;
      //   }
      //   return;
      // }
      // if (trackingawb.length === 0 && nodeData?.tracking_awb?.length === 0) {
      //   setTrackingAwbError("Tracking AWB Number is required");
      // }
      loadSpinner(true);
      setBookingApiError("");
      // console.log(nodeData?.tracking_awb )
      // console.log(
      //   "newsearchformdata",
      //   newsearchformdata,
      //   "00ooooooo0098888888",
      //   newsearchformdata.requestType
      // );
      // Choose the API path by request type: "2" means we are amending an
      // existing offline/manual query (bookingupdate), otherwise "1" creates a
      // brand-new booking (booking). The form value takes precedence over the prop.
      const effectiveRequestType =
        newsearchformdata?.requestType || requestTypeProp;
      if (effectiveRequestType === "2") {
        let searchquery = newsearchformdata?.searchquery || null;
        // console.log(searchquery, "searchquery");
        if (newsearchformdata?.requestType === "2" && searchquery) {
          searchquery = {
            ...searchquery,
            goodsDetails: {
              ...searchquery.goodsDetails,
              commodityId: newsearchformdata?.searchquery?.commodityId
                ? newsearchformdata?.searchquery?.commodityId
                : null,
            },
          };
        }
        // console.log("updated serachquery", searchquery);
        // Resolve LAT/TOA from selectedItem and format them the same way they're
        // displayed (e.g. "360 Mins"; no suffix for QR) so the backend receives
        // what the user sees. Missing values are sent as null.
        const latRaw = selectedItem?.LAT ?? selectedItem?.lat;
        const toaRaw = selectedItem?.TOA ?? selectedItem?.tao;
        const latValue =
          latRaw != null ? `${latRaw}${itemRatesFrom === "QR" ? "" : " Mins"}` : null;
        const toaValue =
          toaRaw != null ? `${toaRaw}${itemRatesFrom === "QR" ? "" : " Mins"}` : null;
        const bookingupdatepayload = {
          // Rate-search keys go first so every key below still wins. Empty for
          // an ocean booking, so this payload is byte-for-byte unchanged there.
          ...rateSearchPayload,
          queryId: rqueryid,
          // selectedItem is spread whole, so an EK rate's
          // productCommodityDetails (incl. specialHandlingCodes) goes as is.
          bookingData: selectedItem
            ? {
                ...selectedItem,
                LAT: latValue,
                TOA: toaValue,
                ...(getEkRateQuotationID(selectedItem) && {
                  rateQuotationID: getEkRateQuotationID(selectedItem),
                }),
              }
            : null,
          searchquery: searchquery || null,
          carrier_type: isOceanBooking ? 2 : 1,
          ...(isOceanBooking
            ? { mblNumber: awbNumber }
            : { airWayBillNumber: awbNumber }),
          requestType: "2",
          // requestType "2" confirms through /bookingUpdate rather than
          // /booking, so the offline rate's space goes out at the root here
          // exactly as it does on the create payload below.
          ...spaceAvailabilityFields,
          ...((selectedValue === "EAP" || selectedValue === "EAW") && {
            specialHandlingCode: selectedValue,
          }),
        };
        // console.log("update123");
        dispatch(bookingupdate(bookingupdatepayload))
          .then((res) => {
            loadSpinner(false);
            if (res?.payload?.data?.statusCode === 201) {
              //  dispatch(clearSearchRateAvailableData())
              dispatch(clearStoredSearch());
              // console.log("Form submitted successfully:", res);
              // console.log("200case")
              dispatch(updatenotificationdata(res?.payload?.data));
              toast.success(
                res?.payload?.data?.message || "Booking updated successfully!",
                {
                  position: "top-center",
                  autoClose: 3000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  // theme: "colored",
                },
              );
              loadSpinner(false);
              onConfirm();
              navigate(redirectPath);
            } else if (res?.payload?.data?.statusCode === 500) {
              dispatch(updatenotificationdata(res?.payload?.data));
              toast.error(res?.payload?.message || "Error updating booking!", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                // theme: "colored",
              });
              loadSpinner(false);
              // onConfirm();
              // navigate(redirectPath);
            } else if (
              res?.payload?.data?.statusCode === 400 ||
              res?.payload?.statusCode === 400 ||
              res?.payload?.data?.success === "error" ||
              res?.payload?.response?.data?.success === "error"
            ) {
              const errData =
                res?.payload?.data ||
                res?.payload?.response?.data ||
                res?.payload;
              dispatch(updatenotificationdata(errData));
              toast.error(
                errData?.message ||
                  "Bad request. Please check the details and try again.",
                {
                  position: "top-center",
                  autoClose: 3000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                },
              );
              loadSpinner(false);
            }

            if (
              Array.isArray(res?.payload?.errors) &&
              res?.payload?.errors.length > 0
            ) {
              // console.log("errorres");
              res.payload.errors.forEach((error) => {
                toast.error(error.msg || "An error occurred!", {
                  position: "top-center",
                  autoClose: 3000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                });
              });
            }
            // else {
            //   toast.error(res?.payload?.error || "Error updating booking!", {
            //     position: "top-center",
            //     autoClose: 3000,
            //     hideProgressBar: true,
            //     closeOnClick: true,
            //     pauseOnHover: true,
            //     draggable: true,
            //   });
            // }
          })
          .catch((error) => {
            console.log(error, "error");
          });
      } else {
        // console.log(
        //   "selectedItem?.flightItenaries?.[0]?.carrierCode",
        //   selectedItem?.flightItenaries?.[0]?.carrierCode
        // );
        // console.log(values,"values12")
        // const updatedValues1 = {
        //   ...values,
        //   bookingData: {
        //     ...values.bookingData,
        //     hash: selectedItem.hash,
        //     // routingPreference: props?.routingPreference,
        //       routingPreference:nodeData1?.manualQuoteId?nodeData1?.routingPreference:props?.routingPreference,
        //     ...(selectedItem?.flightItineraries?.[0]?.carrierCode === "LH" &&
        //       selectedItem?.ratesFrom === "airlineRates" && {
        //         productOffers: {
        //           ...selectedItem?.productOffersReference,
        //           convId: nodeData1?.convId ?? "null",

        //           // convId: props?.convId ?? "null",
        //         },
        //       }),
        //   },
        // };
        // // console.log(updatedValues1, "updatedValues1");
        // // {
        // //   ...values,
        // //   ...(selectedItem?.flightItineraries?.[0]?.carrierCode === "LH"&& selectedItem?.ratesFrom==="airlineRates"&&{
        // //     productOffers: selectedItem?.productOffersReference,
        // //   }),
        // // };

        // // console.log("booking")
        // const condition =
        //   nodeData1?.airlinepayloadData?.productDetails?.specialHandlingCodes?.includes(
        //     "PEP"
        //   ) ||
        //   nodeData1?.airlinepayloadData?.productDetails?.specialHandlingCodes.includes(
        //     "PER"
        //   );
        // const condition2 =
        //   nodeData1?.airlinepayloadData?.productDetails?.productCode === "QFR";
        // const condition3 =
        //   nodeData1?.airlinepayloadData?.temperatureRange || false;
        // const newpayload = {
        //   ...updatedValues1,

        //   pharmaDtls: {
        //     pharmaReqType: "Care",
        //     isPassive: false,
        //   },
        // };
        // const newpayload2 = {
        //   ...updatedValues1,
        //   pharmaDtls: {
        //     pharmaReqType: "Passive",
        //     passivePharmaDtl: {
        //       tnsptTmpTo: nodeData1?.airlinepayloadData?.uppertempbound,
        //       tnsptTmpFrm: nodeData1?.airlinepayloadData?.lowertempbound,
        //       stwgTmpTo: nodeData1?.airlinepayloadData?.uppertempbound,
        //       stwgTmpFrm: nodeData1?.airlinepayloadData?.lowertempbound,
        //       requestType: "Passive",
        //       prdTmpTo: nodeData1?.airlinepayloadData?.uppertempbound,
        //       prdTmpFrm: nodeData1?.airlinepayloadData?.lowertempbound,
        //       instructions: "",
        //     },
        //     isPassive: true,
        //   },
        // };
        // let finalPayload;
        // if (
        //   (condition === true && condition2 === true && condition3) ||
        //   (condition === false && condition2 === true)
        // ) {
        //   finalPayload = newpayload2;
        // } else if (
        //   condition === true &&
        //   condition2 === true &&
        //   condition3 === false
        // ) {
        //   finalPayload = newpayload;
        // } else {
        //   finalPayload = updatedValues1;
        // }
        const bookingPayload = {
          queryId: rqueryid,
          carrier_type: isOceanBooking ? 2 : 1,
          ...(isOceanBooking
            ? { mblNumber: awbNumber, booking_status: "Booking Confirmed" }
            : { airWayBillNumber: awbNumber }),
          requestType: "1",
          // Sent on both air (/booking) and ocean (/ratesearch/create-ocean-
          // booking) so the booked space is recorded either way.
          ...spaceAvailabilityFields,
          ...((selectedValue === "EAP" || selectedValue === "EAW") && {
            specialHandlingCode: selectedValue,
          }),
        };
        // Ocean's KAM "assign MBL & confirm" step uses the dedicated
        // kam/ocean-booking/confirm endpoint (kam role only, matches the
        // backend's checkKam(["kam"]) gate on the create side too). A
        // non-KAM ocean booking here (e.g. air_admin, still on the legacy
        // path) falls back to the shared create-ocean-booking endpoint the
        // customer's own initial booking goes through — the backend upserts
        // on queryId, so calling it again just attaches the MBL number and
        // flips booking_status to confirmed on the existing record.
        // Per-BL rows from the Bill of Lading Details grid — one entry per
        // "No. of BL". Every slot goes out, blank or not, so the saved list
        // always mirrors the grid the KAM saw and BL numbering stays stable:
        // `id` is the 1-based BL number (the row's UI `key`), and a field the
        // KAM left untouched is sent as "" rather than being dropped.
        const blDetails = blRows.map((row, index) => ({
          id: row.key ?? index + 1,
          confirmationNumber: (row.confirmationNumber || "").trim(),
          containerNumber: (row.containerNumber || "").trim(),
          blNumber: (row.blNumber || "").trim(),
        }));
        const bookingAction =
          isOceanBooking && isKam
            ? confirmKamOceanBooking({
                queryId: rqueryid,
                mblNumber: awbNumber,
                blDetails,
              })
            : isOceanBooking
              ? // Ocean keeps the original payload object untouched — only the
                // air branch below carries the rate-search keys.
                createOceanBooking(bookingPayload)
              : booking({ ...rateSearchPayload, ...bookingPayload });
        // createOceanBooking resolves the raw axios response (status on
        // payload.status), while booking's payload nests the backend's own
        // statusCode under payload.data — check both shapes so success is
        // detected either way.
        const isSuccessResponse = (res) =>
          res?.payload?.data?.statusCode === 200 ||
          res?.payload?.statusCode === 200 ||
          res?.payload?.data?.statusCode === 201 ||
          (isOceanBooking &&
            (res?.payload?.status === 200 || res?.payload?.status === 201));
        dispatch(bookingAction)
          .then((res) => {
            // console.log(res,"hii1234")

            loadSpinner(false);
            // dispatch(updatenotificationdata(res?));
            if (isSuccessResponse(res)) {
              //  console.log(res,"hii1234")
              //hii2
              //  const payload =
              //  {

              //    awb_number: "hi",
              //    airline_prefix: "hi",
              //    status: "used", // "available", "used", "blacklisted",
              //    queryId: finalPayload?.queryId,
              //    blacklist_reason: "used",
              //  }

              //  awbstatus(payload);

              // dispatch(clearStoredSearch());
              dispatch(clearStoredSearch());
              dispatch(updatenotificationdata(res?.payload?.data));
              toast.success(
                res?.payload?.data?.message || "Booking created successfully!",
                {
                  position: "top-center",
                  autoClose: 1000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  // theme: "colored",
                },
              );
              // dispatch(clearState());
              dispatch(clearstate());

              loadSpinner(false);
              onConfirm();
              navigate(redirectPath);
            } else if (
              res?.payload?.data?.statusCode === 500 ||
              res?.payload?.statusCode === 500
            ) {
              // console.log(res?.payload, "KOPL");
              dispatch(updatenotificationdata(res?.payload));

              toast.error(
                res?.payload?.error
                  ? res?.payload?.error
                  : res?.payload?.message || "Error creating booking!",
                {
                  position: "top-center",
                  autoClose: 1000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  // theme: "colored",
                },
              );
              loadSpinner(false);
              // onConfirm();
              // navigate(redirectPath);
            } else if (
              res?.payload?.data?.statusCode === 400 ||
              res?.payload?.statusCode === 400 ||
              res?.payload?.data?.success === "error" ||
              res?.payload?.response?.data?.success === "error"
            ) {
              const errData =
                res?.payload?.data ||
                res?.payload?.response?.data ||
                res?.payload;
              dispatch(updatenotificationdata(errData));
              toast.error(
                errData?.message ||
                  "Bad request. Please check the details and try again.",
                {
                  position: "top-center",
                  autoClose: 3000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                },
              );
              loadSpinner(false);
            } else if (!isSuccessResponse(res)) {
              // Fallback for failure shapes without a statusCode field — e.g.
              // create-ocean-booking's `{ success: false, message: "..." }` body
              // (payment not confirmed, etc.) — which would otherwise match
              // neither the 500 nor 400 branches above and fail silently.
              const errData =
                res?.payload?.data ||
                res?.payload?.response?.data ||
                res?.payload;
              toast.error(errData?.message || "Error creating booking!", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
              loadSpinner(false);
            }

            if (
              Array.isArray(res?.payload?.errors) &&
              res?.payload?.errors.length > 0
            ) {
              // console.log("errorres");
              res.payload.errors.forEach((error) => {
                toast.error(error.msg || "An error occurred!", {
                  position: "top-center",
                  autoClose: 1000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                });
              });
            }
            // else {
            //   toast.error(res?.payload?.message || "Error updating booking!", {
            //     position: "top-center",
            //     autoClose: 1000,
            //     hideProgressBar: true,
            //     closeOnClick: true,
            //     pauseOnHover: true,
            //     draggable: true,
            //   });
            // }
          })
          .catch((err) => {
            // console.log(err, "KOPL");
            toast.error(err?.message || "Something went wrong!", {
              position: "top-center",
              autoClose: 1000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              // theme: "colored",
            });
            loadSpinner(false);
          });
      }

      // if(isChecked && !selectedValue && nodeData?.tracking_awb && nodeData?.awb_number){
      // console.log(updatevalues,"updatedvalues")

      // }
    }
  };
  if (!pageMode && !isOpen) return null;
    //  console.log(selectedItem.rateDetails.chargesBreakDown,"chargesbreakdown");
  if (pageMode) {
    return (
      <>
        {spinner && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-10 z-50">
            <Spin />
          </div>
        )}
        <div className="w-full">
          <div className="p-6 flex flex-col gap-4">
            {/* Flight Summary Banner */}
            {selectedItem?.flightItineraries?.length > 0 && (
              <div className="bg-[#FFF9E6] rounded-xl border border-[#F5DFA0] px-5 pt-4 pb-3">
                {/* Top row: airline logo | origin | line+icon | destination */}
                <div className="flex items-center gap-3">
                  {/* Airline logo box */}
                  {selectedItem?.flightItineraries?.[0]?.ailinelogoUrl && (
                    <div className="w-14 h-14 rounded-lg border border-[#e8cc7a] bg-white flex items-center justify-center p-2 shrink-0">
                      <img
                        src={selectedItem.flightItineraries[0].ailinelogoUrl}
                        alt="airline"
                        className="w-full h-full object-contain"
                      />
                    </div>
                  )}

                  {/* Origin: flag + code + date */}
                  <div className="flex items-center gap-2 shrink-0">
                    {originFlag && (
                      <img
                        src={originFlag}
                        alt="origin flag"
                        className="w-7 h-[18px] object-cover rounded-sm shrink-0 shadow-sm"
                      />
                    )}
                    <div>
                      <p className="text-2xl font-bold text-gray-800 leading-tight">
                        {
                          selectedItem?.flightItineraries?.[0]
                            ?.segmentOfDeparture
                        }
                      </p>
                      <p className="text-xs text-gray-500">
                        {moment(
                          selectedItem?.flightItineraries?.[0]
                            ?.scheduledDepartureTime,
                        ).format("DD MMM")}
                      </p>
                    </div>
                  </div>

                  {/* Connecting line + plane icon */}
                  <div className="flex-1 flex items-center">
                    <div className="flex-1 border-t border-[#e8cc7a]"></div>
                    <div className="w-9 h-9 rounded-full bg-[#f1b21b] flex items-center justify-center mx-2 shadow shrink-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        className="w-5 h-5 text-white"
                      >
                        <path d="M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z" />
                      </svg>
                    </div>
                    <div className="flex-1 border-t border-[#e8cc7a]"></div>
                  </div>

                  {/* Destination: code + flag + date */}
                  <div className="flex items-center gap-2 shrink-0">
                    <div className="text-right">
                      <p className="text-2xl font-bold text-gray-800 leading-tight">
                        {
                          selectedItem?.flightItineraries?.[
                            selectedItem?.flightItineraries?.length - 1
                          ]?.segmentOfArrival
                        }
                      </p>
                      <p className="text-xs text-gray-500">
                        {moment(
                          selectedItem?.flightItineraries?.[
                            selectedItem?.flightItineraries?.length - 1
                          ]?.scheduledArrivalTime,
                        ).format("DD MMM")}
                      </p>
                    </div>
                    {destinationFlag && (
                      <img
                        src={destinationFlag}
                        alt="destination flag"
                        className="w-7 h-[18px] object-cover rounded-sm shrink-0 shadow-sm"
                      />
                    )}
                  </div>
                </div>

                {/* Info chips row */}
                <div className="flex items-center gap-1.5 mt-3 flex-wrap">
                  {selectedItem?.flightItineraries?.[0]?.ailinelogoUrl && (
                    <img
                      src={selectedItem.flightItineraries[0].ailinelogoUrl}
                      alt="airline"
                      className="h-4 w-auto object-contain"
                    />
                  )}
                  {[
                    selectedItem?.flightItineraries?.[0]?.carr_name,
                    selectedItem?.flightItineraries?.[0]?.carrierNumber,
                    `⏱ ${MinutesToHours(nodeData1?.bookeditem?.travelTime ?? 0)}`,
                    `LAT: ${latDisplay}`,
                    `TOA: ${toaDisplay}`,
                    // ...(selectedItem?.ratesFrom === "storedrate"
                    //   ? [
                    //       `Lat: ${selectedItem?.lat ?? "N/A"}`,
                    //       `Tao: ${selectedItem?.tao ?? "N/A"}`,
                    //     ]
                    //   : []),
                    // ...(selectedItem?.ratesFrom === "airlineRates" &&
                    // selectedItem?.flightItineraries[0]?.carrierCode === "QR"
                    //   ? [
                    //       `Lat: ${lattaoData?.lat ?? "N/A"}`,
                    //       `Tao: ${lattaoData?.tao ?? "N/A"}`,
                    //     ]
                    //   : []),
                  ]
                    .filter(Boolean)
                    .map((chip, i) => (
                      <span
                        key={i}
                        className="bg-white/70 border border-[#e8d88a] text-gray-700 text-xs font-medium px-3 py-1 rounded-full whitespace-nowrap"
                      >
                        {chip}
                      </span>
                    ))}
                  {/* Commodity — width-capped and truncated (with the full
                      text on hover) so a long description like "Fats and oils
                      (Perishables)" can't push the row apart. */}
                  <span
                    title={
                      gdNatureOfGoods ||
                      newsearchformdata?.searchquery?.goodsDetails?.cargoType ||
                      "General Cargo"
                    }
                    className="bg-white/70 border border-[#e8d88a] text-gray-700 text-xs font-medium px-3 py-1 rounded-full flex items-center gap-1 max-w-[240px] whitespace-nowrap"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-blue-500 inline-block shrink-0"></span>
                    <span className="truncate">
                      {gdNatureOfGoods ||
                        newsearchformdata?.searchquery?.goodsDetails?.cargoType ||
                        "General Cargo"}
                    </span>
                  </span>
                  {/* Carrier codes from the commodity master — each chip is
                      dropped when its code is unknown rather than rendered
                      with an empty value. */}
                  {gdCommodityCode && (
                    <span
                      title={`Commodity Code: ${gdCommodityCode}`}
                      className="bg-white/70 border border-[#e8d88a] text-gray-700 text-xs font-medium px-3 py-1 rounded-full whitespace-nowrap"
                    >
                      Commodity Code: {gdCommodityCode}
                    </span>
                  )}
                  {/* Temperature-controlled shipments only */}
                  {temperatureText && (
                    <span
                      title={`Temperature range: ${temperatureText}`}
                      className="bg-white/70 border border-[#e8d88a] text-gray-700 text-xs font-medium px-3 py-1 rounded-full flex items-center gap-1 whitespace-nowrap"
                    >
                      <Snowflake size={12} className="text-sky-500 shrink-0" />
                      {temperatureText}
                    </span>
                  )}
                  {gdProductCode && (
                    <span
                      title={`Product code: ${gdProductCode}`}
                      className="bg-white/70 border border-[#e8d88a] text-gray-700 text-xs font-medium px-3 py-1 rounded-full whitespace-nowrap"
                    >
                      Product: {gdProductCode}
                    </span>
                  )}
                  {gdShc && (
                    <span
                      title={`Special handling codes: ${gdShc}`}
                      className="bg-white/70 border border-[#e8d88a] text-gray-700 text-xs font-medium px-3 py-1 rounded-full whitespace-nowrap"
                    >
                      SHC: {gdShc}
                    </span>
                  )}
                </div>
              </div>
            )}

            {/* Flight Details Card (Air only — ocean has no flightItineraries) */}
            {!isOceanBooking && selectedItem?.flightItineraries?.length > 0 && (
              <div className="rounded-xl border border-gray-200 bg-white p-4">
                <h4 className="text-base font-bold mb-4 text-gray-800">
                  Flight Details1
                </h4>
                {selectedItem.flightItineraries.map((item, index) => (
                  <div key={index}>
                    <div className="grid grid-cols-3 items-start gap-2">
                      <div>
                        <p className="text-xl font-bold text-gray-800">
                          {item.segmentOfDeparture}
                        </p>
                        <p className="text-sm text-gray-600">
                          {moment(item.scheduledDepartureTime).format(
                            "DD/MM/YYYY HH:mm",
                          )}
                        </p>
                        <p className="text-xs text-gray-400">
                          {getAirportNameByCode(item.segmentOfDeparture)}
                        </p>
                      </div>
                      <div className="flex flex-col items-center justify-center pt-1">
                        <span className="text-gray-400 text-base mb-0.5">✈</span>
                        <span className="text-xs font-medium text-gray-500">
                          {item.carrierNumber}
                        </span>
                      </div>
                      <div className="text-right">
                        <p className="text-xl font-bold text-gray-800">
                          {item.segmentOfArrival}
                        </p>
                        <p className="text-sm text-gray-600">
                          {moment(item.scheduledArrivalTime).format(
                            "DD/MM/YYYY HH:mm",
                          )}
                        </p>
                        <p className="text-xs text-gray-400">
                          {getAirportNameByCode(item.segmentOfArrival)}
                        </p>
                      </div>
                    </div>
                    {index < selectedItem.flightItineraries.length - 1 && (
                      <hr className="my-3 border-gray-100" />
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* Vessel & Schedule Card (Ocean only) */}
            {isOceanBooking && (
              <div className="rounded-xl border border-gray-200 bg-white p-4">
                <h4 className="text-base font-bold mb-4 text-gray-800">
                  Vessel &amp; Schedule
                </h4>
                <div className="grid grid-cols-3 items-start gap-2">
                  <div>
                    <p className="text-xl font-bold text-gray-800">
                      {oceanSchedule?.fromLocation?.unLocCode ||
                        selectedItem?.productOffer?.originPort ||
                        "N/A"}
                    </p>
                    <p className="text-sm text-gray-600">
                      {oceanSchedule?.fromLocation?.departure
                        ? moment(oceanSchedule.fromLocation.departure).format(
                            "DD/MM/YYYY HH:mm",
                          )
                        : "N/A"}
                    </p>
                  </div>
                  <div className="flex flex-col items-center justify-center pt-1">
                    <span className="text-gray-400 text-base mb-0.5">🚢</span>
                    <span className="text-xs font-medium text-gray-500">
                      {selectedItem?.productOffer?.carrierName || "N/A"}
                    </span>
                    {selectedItem?.productOffer?.carrierScac && (
                      <span className="text-[10px] text-gray-400">
                        {selectedItem.productOffer.carrierScac}
                      </span>
                    )}
                  </div>
                  <div className="text-right">
                    <p className="text-xl font-bold text-gray-800">
                      {oceanSchedule?.toLocation?.unLocCode ||
                        selectedItem?.productOffer?.destinationPort ||
                        "N/A"}
                    </p>
                    <p className="text-sm text-gray-600">
                      {oceanSchedule?.toLocation?.arrival
                        ? moment(oceanSchedule.toLocation.arrival).format(
                            "DD/MM/YYYY HH:mm",
                          )
                        : "N/A"}
                    </p>
                  </div>
                </div>
                {oceanContainerItems.length > 0 && (
                  <div className="mt-4 pt-3 border-t border-gray-100">
                    <p className="text-xs font-semibold text-gray-500 uppercase mb-2">
                      Container Details
                    </p>
                    <div className="flex flex-wrap gap-2">
                      {oceanContainerItems.map((c, i) => (
                        <span
                          key={i}
                          className="text-xs bg-gray-100 rounded-full px-3 py-1"
                        >
                          {c?.quantity}× {c?.type} ({containerWeightLabel(c)})
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Payment Summary + Goods Description */}
            <div className="grid grid-cols-2 gap-4">
              <div className="rounded-xl border border-[#F5DFA0] bg-[#FFFCF0] p-4">
                <div className="flex justify-between items-center mb-3">
                  <h3 className="text-base font-bold text-gray-800">
                    Payment Summary
                  </h3>
                  {(isOceanBooking
                    ? oceanSearchquery?.paymentTerms?.incoTerms
                    : searchquery?.paymentTerms?.incoTerms) && (
                    <span className="bg-[#f1b21b] text-white text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide">
                      {isOceanBooking
                        ? oceanSearchquery.paymentTerms.incoTerms
                        : searchquery.paymentTerms.incoTerms}
                    </span>
                  )}
                </div>
                <div className="space-y-2">
                  {renderPaymentBreakdown()}
                  {isOceanBooking && oceanGstInr > 0 && (
                    <>
                      <div className="flex justify-between items-center bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
                        <span className="text-xs font-bold text-amber-700 uppercase tracking-wider">
                          Taxable Amount
                        </span>
                        <span className="text-sm font-bold text-amber-700">
                          {formatOceanUsdThenInr(oceanTaxableUsd, formatOceanAmount(oceanTaxableInr, "INR"))}
                        </span>
                      </div>
                      <div className="bg-slate-50 border border-slate-200 rounded-lg px-3 py-2">
                        <div className="flex justify-between items-center">
                          <span className="text-xs font-bold text-slate-700 uppercase tracking-wider">
                            GST Amount
                          </span>
                          <span className="text-sm font-bold text-slate-700">
                            {formatOceanUsdThenInr(oceanGstUsd, formatOceanAmount(oceanGstInr, "INR"))}
                          </span>
                        </div>
                        <p className="text-xs text-slate-400 mt-0.5">
                          5% on Ocean Freight, 18% on all other charges
                        </p>
                      </div>
                    </>
                  )}
                  <div className="mt-1 flex justify-between items-center bg-[#FFF8EC] border border-amber-200 rounded-lg px-3 py-2">
                    <span className="font-bold text-gray-900 text-sm">
                      Net Amount
                    </span>
                    <span className="font-extrabold text-amber-600 text-base">
                      {isOceanBooking
                        ? (
                          formatOceanUsdThenInr(oceanNetAmountUsd, oceanNetAmountInr)
                        )
                        : formatrates(getAirNetAmount().toFixed(2))}
                    </span>
                  </div>
                </div>
              </div>

              <div className="rounded-xl border border-gray-200 bg-white p-4">
                <h3 className="text-base font-bold mb-3 text-gray-800">
                  Goods Description
                </h3>
                <div className="text-xs p-2 rounded-md text-center text-white bg-[#f1b21b] mb-3">
                  {isOceanBooking
                    ? "To be confirmed by the handling agent at the port"
                    : "To be confirmed by the handling agent at the airport"}
                </div>
                <div className="space-y-2">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">
                      {isOceanBooking ? "Commodity" : "Nature of Goods"}
                    </span>
                    <span className="text-sm text-gray-800">
                      {isOceanBooking
                        ? OCEAN_CARGO_TYPE_CODE_LABELS[
                            nodeData1?.commodity
                          ] ||
                          nodeData1?.commodity ||
                          oceanSearchquery?.goodsDetails
                            ?.commodity_description ||
                          "General Cargo"
                        : gdNatureOfGoods ||
                          newsearchformdata?.searchquery?.goodsDetails
                            ?.cargoType ||
                          "General Cargo"}
                    </span>
                  </div>
                  {/* Carrier codes from the commodity master (air only) — each
                      row is dropped when its code is unknown rather than
                      rendered as "N/A". */}
                  {!isOceanBooking && gdCommodityCode && (
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-500">
                        Commodity Code
                      </span>
                      <span className="text-sm text-gray-800">
                        {gdCommodityCode}
                      </span>
                    </div>
                  )}
                  {!isOceanBooking && gdProductCode && (
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-500">
                        Product Code
                      </span>
                      <span className="text-sm text-gray-800">
                        {gdProductCode}
                      </span>
                    </div>
                  )}
                  {!isOceanBooking && gdShc && (
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-500">
                        Special Handling Codes
                      </span>
                      <span className="text-sm text-gray-800">{gdShc}</span>
                    </div>
                  )}
                  {/* Temperature-controlled air shipments only — ambient cargo
                      carries no range, so the row is dropped rather than shown
                      as "N/A". */}
                  {!isOceanBooking && temperatureText && (
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-500">
                        Temperature Range
                      </span>
                      <span className="text-sm text-gray-800">
                        {temperatureText}
                      </span>
                    </div>
                  )}
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">
                      {isOceanBooking ? "Containers" : "Quantity"}
                    </span>
                    <span className="text-sm text-gray-800">
                      {isOceanBooking
                        ? `${oceanTotalContainers || 0} Containers`
                        : nodeData1?.searchquery?.packagingDetails
                            ?.shipmentTotal?.totalunits
                          ? nodeData1?.searchquery?.packagingDetails
                              ?.shipmentTotal?.totalunits + " Units"
                          : selectedItem?.flightItineraries?.[0]?.pcs +
                            " Units"}
                    </span>
                  </div>
                  {isOceanBooking && (
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-500">
                        Container Type
                      </span>
                      <span className="text-sm text-gray-800">
                        {oceanContainerTypeLabel}
                      </span>
                    </div>
                  )}
                  {isOceanBooking && (
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-500">No. of BL</span>
                      <span className="text-sm text-gray-800">
                        {oceanNoOfBl}
                      </span>
                    </div>
                  )}
                  {/* CBM/CFT is a volume measure for loose (LCL/air) cargo —
                      FCL ocean bookings are described by container type/count
                      instead, so this row is air-only. */}
                  {!isOceanBooking && (
                    <div className="flex justify-between">
                      {/* ── Label switches to "Total CFT" when dim unit is inches ── */}
                      <span className="text-sm text-gray-500">
                        {_nodeVolUnit === "CFT" ? "Total CFT" : "Total CBM"}
                      </span>
                      <span className="text-sm text-gray-800">
                        {(() => {
                            const _vol = nodeData1?.searchquery?.packagingDetails?.shipmentTotal?.totalvolume
                                      ?? selectedItem?.flightItineraries?.[0]?.volume;
                            if (_vol == null) return "N/A";
                            const _base = `${Number(_vol).toFixed(2)} ${_nodeVolUnit}`;
                            return _nodeVolUnit === "CFT"
                              ? `${_base} (${(Number(_vol) * 0.0283168).toFixed(2)} CBM)`
                              : _base;
                          })()}
                      </span>
                    </div>
                  )}
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">
                      {isOceanBooking ? "Total Weight" : "Gross Weight"}
                    </span>
                    <span className="text-sm text-gray-800">
                      {isOceanBooking
                        ? `${oceanTotalKgs || 0} KG`
                        : nodeData1?.searchquery?.packagingDetails
                              ?.shipmentTotal?.totalweight
                          ? nodeData1?.searchquery?.packagingDetails
                              ?.shipmentTotal?.totalweight + " KG"
                          : selectedItem?.flightItineraries?.[0]?.weight +
                            " KG"}
                    </span>
                  </div>
                  {!isOceanBooking && (
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-500">
                        Volumetric Weight
                      </span>
                      <span className="text-sm text-gray-800">
                        {volumeWeightDisplay != null &&
                        !isNaN(volumeWeightDisplay)
                          ? Number(volumeWeightDisplay).toFixed(2) + " KG"
                          : "N/A"}
                      </span>
                    </div>
                  )}
                  {!isOceanBooking && (
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-500">
                        Chargeable Weight
                      </span>
                      <span className="text-sm font-semibold text-blue-600">
                        {(() => {
                          // Trust the API value only when both the chargeable
                          // weight and its unit are present. Otherwise derive it
                          // as the greater of gross vs. volumetric weight.
                          const unit =
                            selectedItem?.rateDetails?.chargeableWeightUnit;
                          const apiChargeable =
                            selectedItem?.rateDetails?.chargeableWeight;
                          if (unit && apiChargeable != null) {
                            return (
                              Math.ceil(Number(apiChargeable)) + " " + unit
                            );
                          }
                          const grossWeight = Number(
                            nodeData1?.searchquery?.packagingDetails
                              ?.shipmentTotal?.totalweight ??
                              selectedItem?.flightItineraries?.[0]?.weight,
                          );
                          const volWeight = Number(volumeWeightDisplay);
                          const valid = [grossWeight, volWeight].filter(
                            (w) => !isNaN(w),
                          );
                          if (valid.length === 0) return "N/A";
                          return Math.ceil(Math.max(...valid)) + " KG";
                        })()}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* AWB (Air) / MBL (Ocean) Number input — KAM only */}
            {isKam && (
              <div className="rounded-xl border border-gray-200 bg-white overflow-hidden">
                {/* ── Section header ── */}
                <div className="flex items-center gap-2.5 px-5 py-3.5 border-b border-gray-100">
                  <span className="w-1 h-5 rounded-full bg-[#f1b21b] shrink-0" />
                  {isOceanBooking ? (
                    /* Ocean — truck/shipping icon */
                    <svg
                      className="w-4 h-4 text-gray-400 shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={1.8}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
                      />
                    </svg>
                  ) : (
                    /* Air — paper plane icon */
                    <svg
                      className="w-4 h-4 text-gray-400 shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={1.8}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                      />
                    </svg>
                  )}
                  <h3 className="text-sm font-bold text-gray-800 tracking-tight">
                    {isOceanBooking
                      ? "Master Bill of Lading (MBL) Number"
                      : "Air Waybill (AWB) Number"}
                  </h3>
                </div>

                {/* ── Input row ── */}
                <div className="px-5 py-4">
                  <div
                    className={`flex items-stretch border rounded-lg overflow-hidden transition-shadow focus-within:ring-2 focus-within:ring-[#f1b21b]/30 focus-within:border-[#f1b21b] ${
                      awbError ? "border-red-400" : "border-gray-200"
                    }`}
                  >
                    {/* Air prefix badge */}
                    {!isOceanBooking &&
                      selectedItem?.flightItineraries?.[0]?.airlinePrefix && (
                        <span className="flex items-center px-3 py-2 text-xs font-bold text-amber-700 bg-amber-50 border-r border-amber-100 shrink-0 select-none tracking-wide">
                          {selectedItem.flightItineraries[0].airlinePrefix}
                          <span className="ml-1 text-amber-300 font-light">—</span>
                        </span>
                      )}
                    {/* Ocean carrier prefix badge */}
                    {isOceanBooking &&
                      (selectedItem?.productOffer?.carrierScac ||
                        selectedItem?.productOffer?.shipping_line_code ||
                        selectedItem?.productOffer?.carrierCode) && (
                        <span className="flex items-center px-3 py-2 text-xs font-bold text-amber-700 bg-amber-50 border-r border-amber-100 shrink-0 select-none tracking-wide">
                          {selectedItem.productOffer.carrierScac ||
                            selectedItem.productOffer.shipping_line_code ||
                            selectedItem.productOffer.carrierCode}
                          <span className="ml-1 text-amber-300 font-light">—</span>
                        </span>
                      )}
                    <input
                      type="text"
                      value={awbNumber}
                      onChange={handleInputChange}
                      readOnly={!isEditable}
                      placeholder={isOceanBooking ? "Enter MBL No" : "Enter AWB No"}
                      className={`flex-1 px-3 py-2.5 text-sm outline-none tracking-wide ${
                        !isEditable
                          ? "bg-gray-50 text-gray-400 cursor-not-allowed"
                          : "bg-white text-gray-700"
                      } placeholder:text-gray-300`}
                    />
                  </div>
                  {awbError && (
                    <p className="flex items-center gap-1 text-xs text-red-500 mt-1.5">
                      <svg className="w-3 h-3 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                          clipRule="evenodd"
                        />
                      </svg>
                      {awbError}
                    </p>
                  )}
                </div>
              </div>
            )}
            {isKam && isOceanBooking && (
              <Bl_notable
                noOfBl={oceanNoOfBl}
                rows={blRows}
                onRowsChange={setBlRows}
              />
            )}

            {/* Terms and Conditions + Confirm Booking */}
            <div className="rounded-xl border border-gray-200 bg-white p-4">
              {!isKam && (
                <div className="flex items-start mb-4">
                  <input
                    className="mt-1 mr-2 shrink-0"
                    type="checkbox"
                    id="termsCheckbox"
                    checked={isChecked}
                    onChange={() => setIsChecked(!isChecked)}
                    disabled={!awbError && !trackingAwbError ? false : true}
                  />
                  <label
                    htmlFor="termsCheckbox"
                    className="text-xs text-gray-600"
                  >
                    I confirm that I have read and understood the{" "}
                    <span
                      className="text-blue-500 underline cursor-pointer"
                      onClick={() => setIsPopupOpen(true)}
                    >
                      Additional Remark
                    </span>{" "}
                    <a
                      href="https://www.qrcargo.com/s/network-and-services/general-terms-and-conditions"
                      className="text-blue-500"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      General and local terms and condition{" "}
                    </a>
                    and{" "}
                    <a
                      href="https://www.qrcargo.com/s/network-and-services/condition-of-carriage"
                      className="text-blue-500"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      condition of carriage{" "}
                    </a>{" "}
                    that apply to this booking
                  </label>
                </div>
              )}
              <button
                className={`w-full text-center text-white rounded-xl py-3 text-base font-semibold transition-colors ${
                  (isKam ? selectedValue : isChecked && selectedValue)
                    ? "bg-[#f1b21b] hover:bg-[#e0a518]"
                    : "bg-gray-300 cursor-not-allowed"
                }`}
                onClick={handleclick}
                disabled={isKam ? !selectedValue : !isChecked || !selectedValue}
              >
                {isKam
                  ? isOceanBooking
                    ? "Assign MBL & Confirm Booking"
                    : "Assign AWB & Confirm Booking"
                  : "Confirm Booking"}
              </button>
            </div>
          </div>
        </div>

        {isPopupOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-md z-50"
            onClick={() => setIsPopupOpen(false)}
          >
            <div
              className="bg-white p-6 rounded-md shadow-lg w-[500px] h-[400px] max-w-full overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <p className="text-sm mb-2">
                Applicable rates and charges are based on their respective
                validity period and will be invoiced accordingly as per issue
                date registered on the master air waybill document.
              </p>
              <ul className="list-disc list-inside text-sm">
                <li>
                  The rate may change if any amendment is done on the booking
                  through manual or electronic (FWB) means.
                </li>
                <li>
                  Shipments containing Dry Ice and Lithium Batteries (ELI/ELM),
                  including Overhang Items (OHG) should not be booked on
                  marketplaces.
                </li>
                <li>
                  Booking cancellation must be performed using the platform
                  through which the booking was created.
                </li>
                <li>
                  Air Plus Solutions offer additional features for shipments
                  booked with compatible products. For added reassurance, Q-Plus
                  increases the loading priority of your shipment.
                </li>
                <li>
                  Other Charges are indicative at the booking stage, and charges
                  related to additional special requirements may not be
                  included. The total sum of Other Charges applicable to the
                  shipment will be available after Air Waybill verification.
                  Complete list of applicable charges and fees (OCDCs) per
                  country due carrier is available on
                  <a
                    href="https://www.qrcargo.com/s/charges-fees"
                    className="text-blue-500"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    QR Cargo website.
                  </a>
                </li>
                <li>
                  Additional remarks indicated on this platform must be taken in
                  conjunction with the
                  <a
                    href="https://www.qrcargo.com/s/network-and-services/general-terms-and-conditions"
                    className="text-blue-500"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    General & Local Terms and Conditions
                  </a>{" "}
                  that apply to all bookings.
                </li>
              </ul>
            </div>
          </div>
        )}
        <ToastContainer />
      </>
    );
  }

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-2xl max-h-[90vh] w-[900px] max-w-full overflow-y-auto shadow-2xl">
          {spinner ? (
            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-5 z-100">
              <Spin />
            </div>
          ) : (
            <div className="p-6 flex flex-col gap-4">
              {nodeData1?.searchquery?.queryQuotingStatus === "Manual" ? (
                <div></div>
              ) : (
                <div
                  className="text-lg font-bold cursor-pointer flex items-center justify-start"
                  onClick={onClose}
                ></div>
              )}

              {/* Flight Summary Card */}
              {selectedItem?.flightItineraries?.length > 0 && (
                <div className="bg-[#FFF9E6] rounded-xl border border-[#F5DFA0] p-4">
                  <div className="flex items-center justify-between">
                    {/* Origin */}
                    <div className="flex items-center gap-3">
                      {selectedItem?.flightItineraries?.[0]?.ailinelogoUrl && (
                        <div className="w-10 h-10 border border-gray-200 rounded-md flex items-center justify-center bg-white p-1 shrink-0">
                          <img
                            src={
                              selectedItem.flightItineraries[0].ailinelogoUrl
                            }
                            alt="airline"
                            className="h-6 w-auto object-contain"
                          />
                        </div>
                      )}
                      <div>
                        <p className="text-2xl font-bold text-gray-800 leading-tight">
                          {
                            selectedItem?.flightItineraries?.[0]
                              ?.segmentOfDeparture
                          }
                        </p>
                        <p className="text-xs text-gray-500">
                          {moment(
                            selectedItem?.flightItineraries?.[0]
                              ?.scheduledDepartureTime,
                          ).format("DD MMM")}
                        </p>
                      </div>
                    </div>

                    {/* Connecting line */}
                    <div className="flex-1 flex items-center px-4">
                      <div className="h-px bg-[#F5DFA0] flex-1"></div>
                      <div className="w-9 h-9 rounded-full bg-[#f1b21b] flex items-center justify-center mx-2 shadow-sm shrink-0">
                        <span className="text-white text-base font-bold">
                          →
                        </span>
                      </div>
                      <div className="h-px bg-[#F5DFA0] flex-1"></div>
                    </div>

                    {/* Destination */}
                    <div className="text-right">
                      <p className="text-2xl font-bold text-gray-800 leading-tight">
                        {
                          selectedItem?.flightItineraries?.[
                            selectedItem?.flightItineraries?.length - 1
                          ]?.segmentOfArrival
                        }
                      </p>
                      <p className="text-xs text-gray-500">
                        {moment(
                          selectedItem?.flightItineraries?.[
                            selectedItem?.flightItineraries?.length - 1
                          ]?.scheduledArrivalTime,
                        ).format("DD MMM")}
                      </p>
                    </div>
                  </div>

                  {/* Flight meta row */}
                  <div className="flex items-center gap-2 mt-3 flex-wrap text-sm text-gray-600">
                    <span className="font-medium">
                      {selectedItem?.flightItineraries?.[0]?.carr_name}
                    </span>
                    <span className="text-gray-300">|</span>
                    <span>
                      {selectedItem?.flightItineraries?.[0]?.carrierNumber}
                    </span>
                    <span className="text-gray-300">|</span>
                    <span className="flex items-center gap-1">
                      <span>⏱</span>
                      <span>
                        {MinutesToHours(selectedItem?.travelTime ?? 0)}
                      </span>
                    </span>
                    <span className="text-gray-300">|</span>
                    <span>LAT: {latDisplay}</span>
                    <span className="text-gray-300">|</span>
                    <span>TOA: {toaDisplay}</span>
                    {/* {selectedItem?.ratesFrom === "storedrate" && (
                      <>
                        <span className="text-gray-300">|</span>
                        <span>
                          Lat: {selectedItem?.lat ? selectedItem?.lat : "N/A"}
                        </span>
                        <span className="text-gray-300">|</span>
                        <span>
                          Tao: {selectedItem?.tao ? selectedItem?.tao : "N/A"}
                        </span>
                      </>
                    )}
                    {selectedItem?.ratesFrom === "airlineRates" &&
                      selectedItem?.flightItineraries?.[0]?.carrierCode ===
                        "QR" && (
                        <>
                          <span className="text-gray-300">|</span>
                          <span>
                            Lat: {lattaoData?.lat ? lattaoData?.lat : "N/A"}
                          </span>
                          <span className="text-gray-300">|</span>
                          <span>
                            Tao: {lattaoData?.tao ? lattaoData?.tao : "N/A"}
                          </span>
                        </>
                      )} */}
                    <span className="text-gray-300">|</span>
                    <span className="flex items-center gap-1">
                      <span className="w-2 h-2 rounded-full bg-blue-500 inline-block"></span>
                      <span>
                        {gdNatureOfGoods ||
                          newsearchformdata?.searchquery?.goodsDetails
                            ?.cargoType ||
                          "General Cargo"}
                      </span>
                    </span>
                    {/* Carrier codes from the commodity master — omitted when
                        the code is unknown. */}
                    {gdCommodityCode && (
                      <>
                        <span className="text-gray-300">|</span>
                        <span>Commodity Code: {gdCommodityCode}</span>
                      </>
                    )}
                    {/* Temperature-controlled shipments only */}
                    {temperatureText && (
                      <>
                        <span className="text-gray-300">|</span>
                        <span className="flex items-center gap-1">
                          <Snowflake
                            size={13}
                            className="text-sky-500 shrink-0"
                          />
                          <span>{temperatureText}</span>
                        </span>
                      </>
                    )}
                    {gdProductCode && (
                      <>
                        <span className="text-gray-300">|</span>
                        <span>Product: {gdProductCode}</span>
                      </>
                    )}
                    {gdShc && (
                      <>
                        <span className="text-gray-300">|</span>
                        <span>SHC: {gdShc}</span>
                      </>
                    )}
                  </div>
                </div>
              )}

              {/* Flight Details Card */}
              <div className="rounded-xl border border-gray-200 bg-white p-4">
                <h4 className="text-base font-bold mb-4 text-gray-800">
                  Flight Details
                </h4>
                {selectedItem?.flightItineraries.map((item, index) => (
                  <div key={index}>
                    <div className="grid grid-cols-3 items-start gap-2">
                      <div>
                        <p className="text-xl font-bold text-gray-800">
                          {item.segmentOfDeparture}
                        </p>
                        <p className="text-sm text-gray-600">
                          {moment(item.scheduledDepartureTime).format(
                            "DD/MM/YYYY HH:mm",
                          )}
                        </p>
                        <p className="text-xs text-gray-400">
                          {getAirportNameByCode(item.segmentOfDeparture)}
                        </p>
                      </div>
                      <div className="flex flex-col items-center justify-center pt-1">
                        <span className="text-gray-400 text-base mb-0.5">
                          ✈
                        </span>
                        <span className="text-xs font-medium text-gray-500">
                          {item.carrierNumber}
                        </span>
                      </div>
                      <div className="text-right">
                        <p className="text-xl font-bold text-gray-800">
                          {item.segmentOfArrival}
                        </p>
                        <p className="text-sm text-gray-600">
                          {moment(item.scheduledArrivalTime).format(
                            "DD/MM/YYYY HH:mm",
                          )}
                        </p>
                        <p className="text-xs text-gray-400">
                          {getAirportNameByCode(item.segmentOfArrival)}
                        </p>
                      </div>
                    </div>
                    {index < selectedItem?.flightItineraries.length - 1 && (
                      <hr className="my-3 border-gray-100" />
                    )}
                  </div>
                ))}
              </div>

              {/* Payment Summary + Goods Description */}
              <div className="grid grid-cols-2 gap-4">
                {/* Payment Summary */}
                <div className="rounded-xl border border-[#F5DFA0] bg-[#FFFCF0] p-4">
                  <div className="flex justify-between items-center mb-3">
                    <h3 className="text-base font-bold text-gray-800">
                      Payment Summary
                    </h3>
                    {searchquery?.paymentTerms?.incoTerms && (
                      <span className="bg-[#f1b21b] text-white text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide">
                        {searchquery.paymentTerms.incoTerms}
                      </span>
                    )}
                  </div>
                  <div className="space-y-2">
                    {renderPaymentBreakdown()}
                    <div className="mt-1 flex justify-between items-center bg-[#FFF8EC] border border-amber-200 rounded-lg px-3 py-2">
                      <span className="font-bold text-gray-900 text-sm">
                        Net Amount
                      </span>
                      <span className="font-extrabold text-amber-600 text-base">
                        {formatrates(getAirNetAmount().toFixed(2))}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Goods Description */}
                <div className="rounded-xl border border-gray-200 bg-white p-4">
                  <h3 className="text-base font-bold mb-3 text-gray-800">
                    Goods Description
                  </h3>
                  <div className="text-xs p-2 rounded-md text-center text-white bg-[#f1b21b] mb-3">
                    To be confirmed by the handling agent at the airport
                  </div>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-500">
                        Nature of Goods
                      </span>
                      <span className="text-sm text-gray-800">
                        {gdNatureOfGoods ||
                          newsearchformdata?.searchquery?.goodsDetails
                            ?.cargoType ||
                          "General Cargo"}
                      </span>
                    </div>
                    {/* Carrier codes from the commodity master — each row is
                        dropped when its code is unknown. */}
                    {gdCommodityCode && (
                      <div className="flex justify-between">
                        <span className="text-sm text-gray-500">
                          Commodity Code
                        </span>
                        <span className="text-sm text-gray-800">
                          {gdCommodityCode}
                        </span>
                      </div>
                    )}
                    {gdProductCode && (
                      <div className="flex justify-between">
                        <span className="text-sm text-gray-500">
                          Product Code
                        </span>
                        <span className="text-sm text-gray-800">
                          {gdProductCode}
                        </span>
                      </div>
                    )}
                    {gdShc && (
                      <div className="flex justify-between">
                        <span className="text-sm text-gray-500">
                          Special Handling Codes
                        </span>
                        <span className="text-sm text-gray-800">{gdShc}</span>
                      </div>
                    )}
                    {/* Temperature-controlled shipments only — omitted for
                        ambient cargo rather than shown as "N/A". */}
                    {temperatureText && (
                      <div className="flex justify-between">
                        <span className="text-sm text-gray-500">
                          Temperature Range
                        </span>
                        <span className="text-sm text-gray-800">
                          {temperatureText}
                        </span>
                      </div>
                    )}
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-500">Quantity</span>
                      <span className="text-sm text-gray-800">
                        {nodeData1?.searchquery?.packagingDetails?.shipmentTotal
                          ?.totalunits
                          ? nodeData1?.searchquery?.packagingDetails
                              ?.shipmentTotal?.totalunits + " Units"
                          : selectedItem?.flightItineraries?.[0]?.pcs + " Units"}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      {/* ── Label switches to "Total CFT" when dim unit is inches ── */}
                      <span className="text-sm text-gray-500">
                        {_nodeVolUnit === "CFT" ? "Total CFT" : "Total CBM"}
                      </span>
                      <span className="text-sm text-gray-800">
                        {nodeData1?.searchquery?.packagingDetails?.shipmentTotal
                          ?.totalvolume
                          ? `${Number(nodeData1.searchquery.packagingDetails.shipmentTotal.totalvolume).toFixed(2)} ${_nodeVolUnit}`
                          : selectedItem?.flightItineraries?.[0]?.volume
                            ? `${Number(selectedItem.flightItineraries[0].volume).toFixed(2)} ${_nodeVolUnit}`
                            : "N/A"}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-500">
                        Gross Weight
                      </span>
                      <span className="text-sm text-gray-800">
                        {nodeData1?.searchquery?.packagingDetails?.shipmentTotal
                          ?.totalweight
                          ? nodeData1?.searchquery?.packagingDetails
                              ?.shipmentTotal?.totalweight + " KG"
                          : selectedItem?.flightItineraries?.[0]?.weight + " KG"}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-500">
                        Volumetric Weight
                      </span>
                      <span className="text-sm text-gray-800">
                        {volumeWeightDisplay != null &&
                        !isNaN(volumeWeightDisplay)
                          ? Number(volumeWeightDisplay).toFixed(2) + " KG"
                          : "N/A"}
                        {/* {totalVolWeight != null && !isNaN(totalVolWeight)
                          ? totalVolWeight.toFixed(2) + " KG"
                          : "N/A"} */}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-500">
                        Chargeable Weight
                      </span>
                      <span className="text-sm font-semibold text-blue-600">
                        {(() => {
                          // Trust the API value only when both the chargeable
                          // weight and its unit are present. Otherwise derive it
                          // as the greater of gross vs. volumetric weight.
                          const unit =
                            selectedItem?.rateDetails?.chargeableWeightUnit;
                          const apiChargeable =
                            selectedItem?.rateDetails?.chargeableWeight;
                          if (unit && apiChargeable != null) {
                            return Math.ceil(Number(apiChargeable)) + " " + unit;
                          }
                          const grossWeight = Number(
                            nodeData1?.searchquery?.packagingDetails
                              ?.shipmentTotal?.totalweight ??
                              selectedItem?.flightItineraries?.[0]?.weight,
                          );
                          const volWeight = Number(volumeWeightDisplay);
                          const valid = [grossWeight, volWeight].filter(
                            (w) => !isNaN(w),
                          );
                          if (valid.length === 0) return "N/A";
                          return Math.ceil(Math.max(...valid)) + " KG";
                        })()}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* AWB (Air) / MBL (Ocean) Number input — KAM only */}
              {isKam && (
                <div className="rounded-xl border border-gray-200 bg-white overflow-hidden">
                  {/* ── Section header ── */}
                  <div className="flex items-center gap-2.5 px-5 py-3.5 border-b border-gray-100">
                    <span className="w-1 h-5 rounded-full bg-[#f1b21b] shrink-0" />
                    {isOceanBooking ? (
                      /* Ocean — anchor icon */
                      <svg
                        className="w-4 h-4 text-gray-400 shrink-0"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={1.8}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
                        />
                      </svg>
                    ) : (
                      /* Air — paper plane icon */
                      <svg
                        className="w-4 h-4 text-gray-400 shrink-0"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={1.8}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                        />
                      </svg>
                    )}
                    <h3 className="text-sm font-bold text-gray-800 tracking-tight">
                      {isOceanBooking
                        ? "Master Bill of Lading (MBL) Number"
                        : "Air Waybill (AWB) Number"}
                    </h3>
                  </div>

                  {/* ── Input row ── */}
                  <div className="px-5 py-4">
                    <div
                      className={`flex items-stretch border rounded-lg overflow-hidden transition-shadow focus-within:ring-2 focus-within:ring-[#f1b21b]/30 focus-within:border-[#f1b21b] ${
                        awbError ? "border-red-400" : "border-gray-200"
                      }`}
                    >
                      {/* Airline prefix badge — air only */}
                      {!isOceanBooking &&
                        selectedItem?.flightItineraries?.[0]?.airlinePrefix && (
                          <span className="flex items-center px-3 py-2 text-xs font-bold text-amber-700 bg-amber-50 border-r border-amber-100 shrink-0 select-none tracking-wide">
                            {selectedItem.flightItineraries[0].airlinePrefix}
                            <span className="ml-1 text-amber-300 font-light">—</span>
                          </span>
                        )}
                      <input
                        type="text"
                        value={awbNumber}
                        onChange={handleInputChange}
                        readOnly={!isEditable}
                        placeholder={isOceanBooking ? "Enter MBL No" : "Enter AWB No"}
                        className={`flex-1 px-3 py-2.5 text-sm outline-none tracking-wide ${
                          !isEditable
                            ? "bg-gray-50 text-gray-400 cursor-not-allowed"
                            : "bg-white text-gray-700"
                        } placeholder:text-gray-300`}
                      />
                    </div>
                    {/* <button
                      type="button"
                      onClick={handleGenerate}
                      className="px-4 py-2 text-sm font-semibold text-white bg-[#f1b21b] hover:bg-[#e0a518] rounded-lg transition-colors shrink-0"
                    >
                      Generate AWB
                    </button> */}
                    {awbError && (
                      <p className="flex items-center gap-1 text-xs text-red-500 mt-1.5">
                        <svg className="w-3 h-3 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clipRule="evenodd"
                          />
                        </svg>
                        {awbError}
                      </p>
                    )}
                  </div>
                </div>
              )}

              {isKam && isOceanBooking && (
                <Bl_notable
                  noOfBl={oceanNoOfBl}
                  rows={blRows}
                  onRowsChange={setBlRows}
                />
              )}

              {/* Terms and Conditions + Confirm Booking */}
              <div className="rounded-xl border border-gray-200 bg-white p-4">
                {!isKam && (
                  <div className="flex items-start mb-4">
                    <input
                      className="mt-1 mr-2 shrink-0"
                      type="checkbox"
                      id="termsCheckbox"
                      checked={isChecked}
                      onChange={() => setIsChecked(!isChecked)}
                      disabled={!awbError && !trackingAwbError ? false : true}
                    />
                    <label
                      htmlFor="termsCheckbox"
                      className="text-xs text-gray-600"
                    >
                      I confirm that I have read and understood the{" "}
                      <span
                        className="text-blue-500 underline cursor-pointer"
                        onClick={() => setIsPopupOpen(true)}
                      >
                        Additional Remark
                      </span>{" "}
                      <a
                        href="https://www.qrcargo.com/s/network-and-services/general-terms-and-conditions"
                        className="text-blue-500"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        General and local terms and condition{" "}
                      </a>
                      and{" "}
                      <a
                        href="https://www.qrcargo.com/s/network-and-services/condition-of-carriage"
                        className="text-blue-500"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        condition of carriage{" "}
                      </a>{" "}
                      that apply to this booking
                    </label>
                  </div>
                )}
                <button
                  className={`w-full text-center text-white rounded-xl py-3 text-base font-semibold transition-colors ${
                    (isKam ? selectedValue : isChecked && selectedValue)
                      ? "bg-[#f1b21b] hover:bg-[#e0a518]"
                      : "bg-gray-300 cursor-not-allowed"
                  }`}
                  onClick={handleclick}
                  disabled={
                    isKam ? !selectedValue : !isChecked || !selectedValue
                  }
                >
                  {isKam
                    ? isOceanBooking
                      ? "Assign MBL & Confirm Booking"
                      : "Assign AWB & Confirm Booking"
                    : "Confirm Booking"}
                </button>
              </div>
            </div>
          )}

          {/* Popup Modal */}
          {isPopupOpen && (
            <div
              className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-md z-50"
              onClick={() => setIsPopupOpen(false)}
            >
              <div
                className="bg-white p-6 rounded-md shadow-lg w-[500px] h-[400px] max-w-full overflow-y-auto"
                onClick={(e) => e.stopPropagation()}
              >
                <p className="text-sm mb-2">
                  Applicable rates and charges are based on their respective
                  validity period and will be invoiced accordingly as per issue
                  date registered on the master air waybill document.
                </p>
                <ul className="list-disc list-inside text-sm">
                  <li>
                    The rate may change if any amendment is done on the booking
                    through manual or electronic (FWB) means.
                  </li>
                  <li>
                    Shipments containing Dry Ice and Lithium Batteries
                    (ELI/ELM), including Overhang Items (OHG) should not be
                    booked on marketplaces.
                  </li>
                  <li>
                    Booking cancellation must be performed using the platform
                    through which the booking was created.
                  </li>
                  <li>
                    Air Plus Solutions offer additional features for shipments
                    booked with compatible products. For added reassurance,
                    Q-Plus increases the loading priority of your shipment.
                  </li>
                  <li>
                    Other Charges are indicative at the booking stage, and
                    charges related to additional special requirements may not
                    be included. The total sum of Other Charges applicable to
                    the shipment will be available after Air Waybill
                    verification. Complete list of applicable charges and fees
                    (OCDCs) per country due carrier is available on
                    <a
                      href="https://www.qrcargo.com/s/charges-fees"
                      className="text-blue-500"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      QR Cargo website.
                    </a>
                  </li>
                  <li>
                    Additional remarks indicated on this platform must be taken
                    in conjunction with the
                    <a
                      href="https://www.qrcargo.com/s/network-and-services/general-terms-and-conditions"
                      className="text-blue-500"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      General & Local Terms and Conditions
                    </a>{" "}
                    that apply to all bookings.
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
        <ToastContainer />
      </div>
      <ToastContainer />
    </>
  );
};

export default Bookingintermediatrypage;
